var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470 424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M160.674 137.137l-28.29-16.361v-75.94l28.29 16.361v75.94z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M160.674 137.137l28.289-16.361v-75.94l-28.289 16.361v75.94z",
    fill: "url(#paint1_linear)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.674 61.197l28.289-16.36-28.289-16.36-28.29 16.36 28.29 16.36z",
    fill: "#F1F7F9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M393.86 181.819v26.205l22.656 13.104c0-14.473-10.143-32.073-22.656-39.309z",
    fill: "#00C0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398.138 179.345l-15.489 8.958 22.195 39.575 15.949-9.224c0-14.474-10.143-32.073-22.655-39.309z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.86 181.819v26.205l22.656 13.104c0-14.473-10.143-32.073-22.656-39.309z",
    fill: "#F77D48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M416.516 221.128l-22.656-13.104 20.06 23.779c1.655-2.682 2.596-6.279 2.596-10.675z",
    fill: "#00C0F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.86 208.024v-26.205c-12.513-7.236-22.655-1.37-22.655 13.102 0 14.473 10.142 32.072 22.655 39.309 8.711 5.038 16.269 3.719 20.06-2.427l-20.06-23.779z",
    fill: "#0E7C9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M398.138 179.345c-6.293-3.64-11.986-3.962-16.091-1.545l-3.993 2.309.004.007c4.082-2.239 9.654-1.853 15.802 1.703l4.278-2.474z",
    fill: "#F7FBFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M414.562 233.089a11.69 11.69 0 003.636-3.759l-4.278 2.473a11.672 11.672 0 01-3.636 3.76l4.278-2.474z",
    fill: "#A3C6D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M418.198 229.33c1.655-2.682 2.595-6.279 2.595-10.676l-4.277 2.474c0 4.396-.941 7.993-2.596 10.675l4.278-2.473z",
    fill: "#00C0F3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M303.735 236.88h49.972l-31.239 18.626 31.239 18.072h-49.972l-31.717-18.343 31.717-18.355z",
    fill: "url(#paint3_linear)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M353.707 273.578l-31.239-18.072v-65.943l31.239 18.066v65.949z",
    fill: "#B9DBE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353.707 273.578l31.244-18.072v-65.943l-31.244 18.066v65.949z",
    fill: "#CCEDF6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.707 207.629l31.244-18.066-31.244-18.06-31.239 18.06 31.239 18.066z",
    fill: "#F4F8F9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M186.021 351.469h28.87l-18.048 10.76 18.048 10.442h-28.87l-18.324-10.598 18.324-10.604z",
    fill: "url(#paint4_linear)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.891 372.671l-18.048-10.442v-38.097l18.048 10.437v38.102z",
    fill: "#3E97AF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.891 372.671l18.05-10.442v-38.097l-18.05 10.437v38.102z",
    fill: "#67CDE9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.891 334.569l18.05-10.437-18.05-10.434-18.048 10.434 18.048 10.437z",
    fill: "#F4F8F9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M57.542 199.344h57.244L79.001 220.68l35.785 20.704H57.542l-36.334-21.015 36.334-21.025z",
    fill: "url(#paint5_linear)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.786 241.384L79.001 220.68v-75.541l35.785 20.695v75.55z",
    fill: "#B9DBE4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.786 241.384l35.792-20.704v-75.541l-35.792 20.695v75.55z",
    fill: "#CCEDF6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.786 165.834l35.792-20.695-35.792-20.69-35.785 20.69 35.785 20.695zM335.134 232.793c0-1.779-1.258-3.961-2.797-4.851l-19.153-11.077c-1.537-.889-2.795-.162-2.795 1.617v17.801c0 1.78 1.258 3.962 2.795 4.851l19.153 11.078c1.539.889 2.797.162 2.797-1.616v-17.803z",
    fill: "#F4F8F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M335.134 250.596v-17.803c0-1.779-1.258-3.961-2.797-4.851l-19.153-11.077c-.759-.439-1.45-.483-1.955-.201l1.463-.846.002.003c.511-.328 1.23-.304 2.026.156l19.153 11.077c1.537.89 2.795 3.072 2.795 4.851v17.802c0 .931-.346 1.57-.895 1.844l-1.393.807c.465-.31.754-.915.754-1.762z",
    fill: "url(#paint6_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M321.075 227.698a.986.986 0 01.584.721l2.715 12.916c.07.333-.078.55-.331.485a.986.986 0 01-.584-.721l-2.715-12.916c-.07-.333.078-.55.331-.485zm3.744 4.499c.148-.164.444-.056.66.241l4.549 6.251c.125.165.197.365.206.572 0 .181-.076.306-.206.334l-4.549.989c-.216.047-.512-.188-.66-.524-.149-.335-.094-.646.121-.693l3.981-.866-3.981-5.469c-.215-.297-.27-.671-.121-.835zm-10.059-2.338l4.549-.989c.216-.048.513.187.661.523.149.336.094.646-.122.693l-3.981.865 3.981 5.471c.216.296.271.67.122.834-.148.164-.444.056-.661-.241l-4.549-6.251a1.022 1.022 0 01-.206-.572c0-.181.077-.306.206-.333z",
    fill: "#67CDE9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M96.28 146.841a1.556 1.556 0 00-.54-.355h-2.38l-.994-2.18.897-.138c.293-.042.577-.136.837-.278a.853.853 0 00.498-.738c-.021-.289-.02-.58.004-.868.019-.623-.742-.926-1.32-1.018l-.897-.139 1.018-2.178h2.376a1.604 1.604 0 00.547-.356c.236-.265.488-.516.753-.752.552-.535.156-1.02-.267-1.265l-.654-.382 2.758-1.594.654.38a2.715 2.715 0 002.181.159 20.39 20.39 0 011.299-.435c.148-.046.291-.108.427-.184.529-.307.556-.716.431-.991l-.236-.519 3.758-.585.236.521c.151.336.674.779 1.747.771.498-.013.999-.013 1.495-.001.443.02.885-.078 1.278-.286.205-.109.372-.277.48-.483l.242-.522 3.752.585-.243.519c-.157.337-.088.872.844 1.175.441.133.874.278 1.296.435a2.725 2.725 0 002.182-.157l.658-.382 2.74 1.594-.659.382c-.423.246-.825.73-.28 1.264a10 10 0 01.746.753c.52.542 1.438.584 2.018.496l.9-.14.994 2.178-.898.139a2.529 2.529 0 00-.837.279.861.861 0 00-.499.739c.022.288.022.577 0 .865a.73.73 0 00.247.563h6.127v2.774h-7.555a1.58 1.58 0 00-.543.354c-.237.265-.49.516-.755.753a.945.945 0 00-.217.299h3.558v2.942h-5.383v-.12l-.449-.26a2.703 2.703 0 00-2.181-.158c-.165.06-.333.119-.501.177v2.535h-5.145v-.006l-.032.006-.238-.521a1.068 1.068 0 00-.064-.114v.635h-5.177l-3.752-.583.244-.521c.14-.3.097-.759-.582-1.07h-4.4l-2.738-1.594.657-.381c.425-.247.827-.732.28-1.266a9.044 9.044 0 01-.743-.752zm8.825-1.229c2.759 1.605 7.251 1.608 10.029 0 2.777-1.606 2.79-4.213.032-5.818-2.761-1.607-7.251-1.607-10.028 0-2.778 1.607-2.793 4.211-.033 5.818z",
    fill: "url(#paint7_linear)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.346 135.133c2.758-1.594 7.217-1.595 9.959 0 2.438 1.419 2.694 3.626.775 5.218a5.874 5.874 0 00-.775-.536c-2.742-1.597-7.201-1.596-9.959 0a5.805 5.805 0 00-.808.558c-1.929-1.594-1.658-3.814.808-5.24z",
    fill: "url(#paint8_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.071 128.834a.678.678 0 01.064.28l.013 4.695a.692.692 0 00-.062-.28l-.238-.519-.013-4.695.236.519zm12.51 0l.242-.519.013 4.695-.242.519a.687.687 0 00-.065.292l-.014-4.697c0-.101.023-.2.066-.29zm-19.604 3.046a.94.94 0 01.536.727l.013 4.696a.936.936 0 00-.536-.727l-.654-.382-.014-4.695.655.381z",
    fill: "#BBDAE2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.642 131.88l.659-.381.013 4.695-.659.382a.95.95 0 00-.545.736l-.013-4.697a.959.959 0 01.178-.438.964.964 0 01.367-.297z",
    fill: "#CEECF4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M98.447 136.57c.57.089 1.316.387 1.318.993l.013 4.696c-.002-.605-.748-.902-1.318-.993l-.899-.139-.013-4.696.898.139z",
    fill: "#BBDAE2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.747 138.058l.013 4.696c0 .132.005.265.014.398l-.011-4.696a4.92 4.92 0 01-.016-.398z",
    fill: "#024455"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M130.788 138.364l-.002-.776a.852.852 0 01.499-.739c.26-.142.543-.236.836-.278l.899-.14.013 4.696-.898.139a2.523 2.523 0 00-.836.279.906.906 0 00-.484.594l.002.549c0 .154-.007.308-.018.461l-.014-4.695.003-.09z",
    fill: "#CEECF4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M130.785 138.478l.013 4.696.001-.025-.014-4.695v.024z",
    fill: "#024455"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.53 139.611l.014 4.695.993 2.18-.012-4.695-.994-2.18z",
    fill: "#BBDAE2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.983 141.791l.013 4.695 1.018-2.179-.014-4.696-1.017 2.18z",
    fill: "#CEECF4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.423 141.649c.58-.088 1.499-.046 2.02.496.233.265.482.516.745.752a.764.764 0 01.265.528l.012 4.697a.746.746 0 00-.265-.529 9.09 9.09 0 01-.743-.752c-.521-.544-1.443-.584-2.02-.495l-.9.14-.012-4.695.898-.142z",
    fill: "url(#paint9_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M128.307 142.897c.265-.236.517-.487.754-.752.095-.097.203-.18.321-.247a2.77 2.77 0 011.706-.249l.895.142.013 4.695-.895-.14a2.762 2.762 0 00-1.706.248 1.467 1.467 0 00-.32.246 9.411 9.411 0 01-.755.753.74.74 0 00-.27.538l-.013-4.695a.753.753 0 01.27-.539z",
    fill: "url(#paint10_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 144.543l.012 4.697 2.74 1.594-.013-4.696-2.739-1.595z",
    fill: "#BBDAE2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.469 146.138l.015 4.696 2.757-1.594-.013-4.697-2.759 1.595z",
    fill: "#CEECF4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.647 145.757a2.716 2.716 0 012.181-.157c.422.157.855.303 1.296.434.693.227.909.58.911.885l.012 4.695c-.001-.305-.217-.658-.91-.884a19.463 19.463 0 01-1.295-.434 2.701 2.701 0 00-2.18.157l-.66.381-.013-4.696.658-.381z",
    fill: "url(#paint11_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.91 146.219c.135-.076.278-.138.426-.185.443-.131.876-.277 1.298-.434a2.709 2.709 0 012.181.157l.654.381.015 4.696-.654-.38a2.703 2.703 0 00-2.182-.158c-.423.157-.856.303-1.299.434a2.265 2.265 0 00-.426.184.834.834 0 00-.494.711l-.013-4.694a.836.836 0 01.494-.712z",
    fill: "url(#paint12_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M108.725 147.729l.014 4.696 3.752.583-.013-4.696-3.753-.583z",
    fill: "#BBDAE2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M112.72 147.791c.108-.206.276-.375.482-.484a2.482 2.482 0 011.276-.284c.497.01.997.01 1.495-.003 1.072-.006 1.592.436 1.746.771l.237.521.014 4.696-.237-.521c-.155-.336-.675-.778-1.746-.77-.5.013-1 .012-1.495 0a2.499 2.499 0 00-1.277.285 1.162 1.162 0 00-.482.485l-.242.521-.013-4.696.242-.521z",
    fill: "url(#paint13_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M101.906 144.164l-.657.379 2.74 1.595.658-.381a2.716 2.716 0 012.181-.157c.422.157.855.303 1.296.434.933.305 1.002.839.845 1.175l-.244.52 3.753.583.242-.521c.108-.206.276-.375.482-.484a2.48 2.48 0 011.275-.284c.498.01.998.01 1.496-.003 1.072-.006 1.592.437 1.746.771l.237.521 3.759-.583-.239-.521c-.124-.275-.095-.682.434-.989.135-.076.278-.138.426-.185.443-.131.876-.277 1.298-.434a2.709 2.709 0 012.181.157l.654.381 2.759-1.595-.655-.38c-.422-.245-.818-.73-.266-1.266.265-.236.517-.487.754-.752.095-.097.203-.18.321-.247a2.77 2.77 0 011.706-.249l.895.142 1.017-2.179-.895-.139c-.579-.092-1.338-.395-1.32-1.019.023-.288.023-.578.001-.866a.852.852 0 01.499-.739c.26-.142.543-.236.836-.278l.899-.14-.995-2.177-.9.139c-.579.09-1.499.047-2.018-.494a9.453 9.453 0 00-.745-.753c-.546-.536-.145-1.021.28-1.266l.658-.381-2.739-1.596-.66.383a2.701 2.701 0 01-2.179.157 22.378 22.378 0 00-1.296-.435c-.933-.303-1.002-.837-.845-1.174l.242-.519-3.751-.584-.242.52a1.146 1.146 0 01-.481.484 2.48 2.48 0 01-1.278.285 28.624 28.624 0 00-1.494.002c-1.073.008-1.595-.435-1.746-.772l-.239-.519-3.757.584.236.519c.126.276.1.684-.431.99a2.07 2.07 0 01-.427.184c-.441.133-.875.278-1.299.435a2.704 2.704 0 01-2.181-.159l-.654-.381-2.757 1.596.655.381c.421.245.818.729.264 1.267a9.528 9.528 0 00-.752.752 1.506 1.506 0 01-.32.246 2.758 2.758 0 01-1.707.247l-.896-.14-1.017 2.179.897.139c.578.092 1.337.396 1.318 1.018a5.849 5.849 0 00-.001.868.857.857 0 01-.5.738c-.26.142-.543.236-.837.279l-.895.139.994 2.179.898-.142c.58-.088 1.499-.046 2.02.496.233.265.482.516.745.752.546.536.143 1.021-.282 1.267zm18.39-3.246c-2.776 1.606-7.267 1.604-10.027-.001-2.76-1.608-2.745-4.212.033-5.818 2.777-1.607 7.267-1.608 10.027 0 2.759 1.606 2.746 4.212-.033 5.819z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.956 148.312l.014 4.696 3.758-.583-.013-4.696-3.759.583z",
    fill: "#CEECF4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.273 134.304c3.911-2.261 10.23-2.263 14.117 0 1.85 1.077 2.812 2.473 2.892 3.884-.076 1.428-1.054 2.847-2.938 3.936-3.91 2.26-10.23 2.259-14.114-.003-1.851-1.078-2.814-2.472-2.894-3.884.075-1.428 1.054-2.843 2.937-3.933zm2.042 6.614c2.739 1.593 7.199 1.594 9.956 0 1.306-.756 1.996-1.733 2.072-2.722-.079-.977-.757-1.941-2.038-2.685-2.742-1.597-7.201-1.596-9.959-.001-1.306.755-1.995 1.733-2.07 2.721.078.977.756 1.938 2.039 2.687z",
    fill: "#E0E9EB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M122.39 134.304c-3.887-2.263-10.206-2.261-14.117 0-1.883 1.088-2.861 2.504-2.937 3.931-.09-1.552.889-3.122 2.937-4.306 3.911-2.263 10.23-2.265 14.117 0 2.013 1.171 2.975 2.72 2.892 4.256-.081-1.41-1.044-2.804-2.892-3.881z",
    fill: "url(#paint14_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M245.173 381.592c.219-.375.471-.731.754-1.061 1.024-1.02-1.337-2.725-2.402-3.34-.02 0 3.105-1.809 3.105-1.809l9.186.011c.5-.702.77-1.543.772-2.405l4.408-.001c.001.719.295 2.329 1.512 3.031.274.158.576.263.89.308.625.12 1.239.267 1.835.439a.217.217 0 00.076-.013 22.06 22.06 0 011.829-.439c1.969-.298 2.373-2.469 2.369-3.339h4.408c.001.718.293 2.329 1.511 3.032.275.158.577.261.89.306.624.122 1.239.269 1.833.44 2.031.439 4.689-.765 5.748-1.381l3.126 1.807c-1.06.616-3.399 2.322-2.364 3.337.287.331.543.687.764 1.065.121.222.306.402.531.515 1.217.703 3.991.868 5.236.868l.008 2.557c-1.5 0-5.241.241-5.745 1.383a6.792 6.792 0 01-.753 1.063c-1.024 1.018 1.337 2.722 2.402 3.34l-3.106 1.808a11.942 11.942 0 00-.385-.21l.363.21-9.179.011a4.145 4.145 0 00-.754 2.385l-17.322.014c0-.002-4.317-2.403-4.317-2.403l-5.672.005-3.127-1.807c1.061-.617 3.401-2.323 2.365-3.339a7.059 7.059 0 01-.488-.643l-2.908.003-3.125-1.808c-.003 0-.018-2.555-.018-2.555 1.608.063 5.24-.242 5.744-1.385z",
    fill: "url(#paint15_linear)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M284.4 372.47c.003-.992 1.749-2.242 2.623-2.751l-.021 7.459c-.873.508-2.621 1.757-2.622 2.751l.02-7.459z",
    fill: "#F5F9FA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M256.421 377.178l.021-7.459c.883.51 2.657 1.77 2.654 2.765l-.021 7.459c.002-.995-1.77-2.253-2.654-2.765z",
    fill: "#B9DEE8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.256 381.04c-3.064-1.771-8.003-1.771-11.046 0-1.51.878-2.266 2.028-2.27 3.182l.022-7.459c.005-1.152.76-2.303 2.271-3.182 3.041-1.77 7.982-1.77 11.043 0 1.539.889 2.307 2.058 2.303 3.223l-.021 7.459c.004-1.166-.765-2.334-2.302-3.223z",
    fill: "url(#paint16_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M283.996 385.656l3.106-1.809-.022 7.459-3.106 1.808.022-7.458z",
    fill: "#CCF0FA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 391.306l.02-7.459 3.128 1.809-.021 7.458-3.127-1.808z",
    fill: "#B9DEE8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M278.213 391.731c-.594.172-1.206.319-1.83.44-1.943.292-2.36 2.414-2.363 3.305l.021-7.459c.003-.891.421-3.011 2.363-3.304a21.237 21.237 0 001.83-.44c1.751-.597 4.697.765 5.762 1.383l-.022 7.458c-1.065-.618-4.01-1.981-5.761-1.383z",
    fill: "url(#paint17_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M268.092 392.473a2.526 2.526 0 00-.885-.302 21.985 21.985 0 01-1.83-.438c-1.761-.6-4.692.763-5.75 1.381l.021-7.458c1.058-.617 3.989-1.98 5.749-1.382.599.17 1.207.318 1.83.439.312.045.613.147.887.302 1.2.695 1.454 2.281 1.522 3.036l-.021 7.458c-.069-.755-.322-2.342-1.523-3.036z",
    fill: "url(#paint18_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M284.7 380.508c-1.023 1.018 1.337 2.723 2.402 3.339l-3.106 1.809c-1.065-.618-4.011-1.98-5.762-1.383-.593.171-1.207.319-1.83.44-1.966.294-2.37 2.468-2.363 3.338h-4.405c-.068-.755-.322-2.341-1.522-3.036a2.537 2.537 0 00-.887-.302 22.18 22.18 0 01-1.83-.439c-1.76-.598-4.692.765-5.749 1.382l-3.128-1.809c1.061-.615 3.402-2.321 2.367-3.339a7.222 7.222 0 01-.766-1.063 1.234 1.234 0 00-.531-.515c-1.214-.704-3.989-.869-5.228-.867l-.014-2.558c1.608.064 5.24-.241 5.743-1.385.219-.375.471-.731.753-1.061 1.024-1.019-1.336-2.724-2.402-3.34l3.107-1.808c1.065.616 4.012 1.98 5.76 1.382.597-.17 1.207-.316 1.829-.439 1.969-.297 2.373-2.469 2.369-3.337l4.408-.003c.001.721.294 2.332 1.511 3.035.275.157.577.26.89.305.624.122 1.239.268 1.833.439 2.031.439 4.689-.766 5.748-1.382l3.126 1.808c-1.06.616-3.399 2.322-2.364 3.338.287.331.543.687.764 1.065.121.222.306.402.531.516 1.217.702 3.991.867 5.236.867l.008 2.558c-1.5-.002-5.241.24-5.745 1.382a6.831 6.831 0 01-.753 1.063zm-7.424-6.927c-3.061-1.77-8.002-1.77-11.043 0-3.039 1.77-3.026 4.637.035 6.409 3.058 1.769 8.002 1.767 11.041-.002 3.042-1.772 3.025-4.637-.033-6.407z",
    fill: "#F4F8F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M287.102 383.847c-1.065-.616-3.425-2.321-2.402-3.338.284-.33.536-.686.753-1.064.504-1.142 4.245-1.384 5.745-1.382l-.022 7.457a18.525 18.525 0 00-4.079.44l.005-2.113z",
    fill: "#CCF0FA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M269.615 395.509l.021-7.458h4.405l-.021 7.459-4.405-.001z",
    fill: "#B9DEE8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M252.341 385.519l.022-7.456c1.238-.002 4.013.163 5.227.867.226.113.411.293.531.515.223.377.479.733.766 1.064 1.035 1.017-1.306 2.723-2.367 3.338l-.006 2.143a18.366 18.366 0 00-4.173-.471z",
    fill: "url(#paint19_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.304 292.454h13.939l-8.714 5.195 8.714 5.04H30.304l-8.845-5.116 8.845-5.119z",
    fill: "url(#paint20_linear)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.243 302.689l-8.714-5.04v-10.233l8.714 5.038v10.235z",
    fill: "#3E97AF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M44.243 302.689l8.713-5.04v-10.233l-8.713 5.038v10.235z",
    fill: "#00C0F3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M44.243 292.454l8.713-5.038-8.713-5.038-8.714 5.038 8.714 5.038z",
    fill: "#00C0F3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M301.856 303.759h12.593l-7.873 4.694 7.873 4.554h-12.593l-7.993-4.623 7.993-4.625z",
    fill: "url(#paint21_linear)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M314.449 313.007l-7.873-4.554v-9.247l7.873 4.553v9.248zM314.449 313.007l7.874-4.554v-9.247l-7.874 4.553v9.248z",
    fill: "#F77D48"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M314.449 303.759l7.874-4.553-7.874-4.551-7.873 4.551 7.873 4.553z",
    fill: "#FFAF6D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M297.355 185.187h51.965l4.722 3.642-.333 3.644h-43.758l-12.596-7.286z",
    fill: "url(#paint22_linear)"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M362.926 187.385c-2.517 2.522-7.941 4.768-9.217 5.088-1.276-.32-6.699-2.566-9.216-5.088a164.272 164.272 0 0118.433 0z",
    fill: "#4193AA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M364.099 177.005v7.605c0 1.537-1.015 3.075-3.043 4.249-4.057 2.346-10.635 2.346-14.692 0-2.029-1.174-3.044-2.712-3.044-4.249v-7.605h20.779z",
    fill: "url(#paint23_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M342.698 180.877a.651.651 0 01.328-.523 4.157 4.157 0 01-.343-1.638.676.676 0 01.621-.604c.31 0 0 .604 0 .604h.144c0 1.501 1.038 2.928 2.924 4.019 4.041 2.337 10.618 2.337 14.66 0 1.885-1.091 2.924-2.517 2.924-4.019h.159s-.309-.604.001-.604a.653.653 0 01.606.604 4.127 4.127 0 01-.342 1.632.658.658 0 01.342.529 4.136 4.136 0 01-.341 1.629.655.655 0 01.341.529c0 1.786-1.175 3.449-3.307 4.683-4.253 2.459-11.173 2.459-15.426 0-2.132-1.234-3.306-2.897-3.306-4.683a.705.705 0 01.343-.52 3.88 3.88 0 01-.328-1.638zm3.674 6.176c4.041 2.337 10.618 2.337 14.66 0 1.771-1.024 2.793-2.344 2.912-3.744a7.513 7.513 0 01-2.529 2.25c-4.253 2.459-11.173 2.459-15.426 0a7.513 7.513 0 01-2.529-2.25c.118 1.399 1.142 2.72 2.912 3.744zm0-2.159c4.041 2.338 10.618 2.338 14.66 0 1.771-1.025 2.793-2.345 2.912-3.745a7.516 7.516 0 01-2.529 2.251c-4.253 2.458-11.173 2.458-15.426 0a7.516 7.516 0 01-2.529-2.251c.118 1.4 1.141 2.72 2.912 3.745z",
    fill: "url(#paint24_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.304 158.89a18.467 18.467 0 012.185-8.72 18.418 18.418 0 016.042-6.648 18.386 18.386 0 018.462-2.996 18.386 18.386 0 0116.04 6.778 18.461 18.461 0 01-1.483 24.789c-1.398 1.406-1.745 3.947-1.745 4.66 0 1.642-1.082 3.284-3.25 4.538-4.333 2.506-11.359 2.505-15.691 0-2.167-1.254-3.25-2.896-3.25-4.538 0-.713-.347-3.254-1.757-4.668a18.4 18.4 0 01-5.553-13.195z",
    fill: "url(#paint25_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M361.555 172.216c-4.333-2.506-11.357-2.506-15.691 0-4.334 2.506-4.334 6.568 0 9.075 4.332 2.505 11.358 2.506 15.691 0 4.334-2.507 4.334-6.57 0-9.075z",
    fill: "url(#paint26_linear)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M368.399 160.472a1.583 1.583 0 001.117-.463c.147-.147.263-.322.342-.514.08-.192.121-.398.121-.605a16.331 16.331 0 00-4.771-11.519 16.27 16.27 0 00-11.499-4.779 1.57 1.57 0 00-1.118.463 1.572 1.572 0 00-.464 1.119 1.576 1.576 0 00.464 1.12 1.588 1.588 0 001.118.463 13.114 13.114 0 019.266 3.851 13.157 13.157 0 013.843 9.282 1.59 1.59 0 00.976 1.462c.192.079.397.12.605.12z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M349.596 156.703a.711.711 0 01.74.005c.508.294.885 1.254 1.129 2.475a1.81 1.81 0 01.659-1.018.71.71 0 01.739.005c.508.294.886 1.254 1.13 2.473.096-.404.328-.763.657-1.017a.714.714 0 01.741.006c.507.293.885 1.253 1.129 2.473.096-.405.329-.764.658-1.018a.719.719 0 01.739.006c.956.553 1.456 3.453 1.456 6.032 0 2.627-.625 3.402-1.229 4.152-.638.794-1.299 1.613-1.299 5.119a.384.384 0 01-.653.271.384.384 0 01-.112-.271c0-3.775.78-4.745 1.468-5.599.568-.707 1.059-1.317 1.059-3.672 0-2.923-.617-5.079-1.064-5.361-.247.165-.698 1.457-.698 3.9a.384.384 0 01-.653.271.384.384 0 01-.112-.271c0-2.923-.616-5.079-1.063-5.362-.248.166-.699 1.458-.699 3.9a.383.383 0 11-.766 0c0-2.923-.616-5.079-1.063-5.36-.247.164-.698 1.456-.698 3.899a.382.382 0 11-.766 0c0-2.924-.616-5.079-1.062-5.362-.248.166-.699 1.459-.699 3.9 0 2.426.544 3.747 1.122 5.147.659 1.595 1.405 3.403 1.405 7.047a.382.382 0 11-.766 0c0-3.492-.684-5.151-1.347-6.755-.605-1.471-1.18-2.861-1.18-5.439 0-1.905.289-4.107 1.098-4.576z",
    fill: "url(#paint27_linear)"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M353.935 137.647a.791.791 0 00.79-.792v-9.406a.79.79 0 10-1.579 0v9.406a.794.794 0 00.789.792zm-10.538 2.693a.789.789 0 00.693-1.17l-3.15-5.782a.787.787 0 00-1.451.155.793.793 0 00.064.602l3.15 5.783a.78.78 0 00.291.301.784.784 0 00.403.111zm21.076 0a.794.794 0 00.694-.412l3.151-5.782a.783.783 0 00.065-.603.788.788 0 00-1.451-.156l-3.152 5.782a.806.806 0 00-.096.394.785.785 0 00.398.673.789.789 0 00.391.104z",
    fill: "#FFC16B"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M267.319 259.434c.001-9.5-6.266-19.001-18.799-26.25-25.067-14.496-65.71-14.496-90.777.001-12.533 7.249-18.8 16.749-18.8 26.249-.001 9.501 6.266 19.001 18.8 26.25 25.067 14.497 65.71 14.497 90.776 0 12.533-7.249 18.8-16.749 18.8-26.25z",
    fill: "url(#paint28_linear)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M171.465 277.289c25.067 14.497 65.71 14.496 90.777-.001 12.533-7.249 18.799-16.749 18.8-26.249v8.396c-.001 9.5-6.267 19-18.8 26.249-25.067 14.497-65.71 14.497-90.777 0-12.533-7.248-18.8-16.749-18.8-26.249v-8.396c0 9.5 6.267 19.001 18.8 26.25z",
    fill: "url(#paint29_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M281.042 251.039c0-9.501-6.266-19.001-18.8-26.25-25.067-14.497-65.709-14.497-90.777 0-12.533 7.249-18.8 16.749-18.8 26.25 0 9.5 6.267 19.001 18.8 26.25 25.067 14.497 65.71 14.496 90.777-.001 12.533-7.249 18.799-16.749 18.8-26.249z",
    fill: "#F4F8F9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M152.665 251.039c0-9.5 6.267-19.001 18.8-26.25 5.43-3.139 11.592-5.597 18.167-7.377l25.892 55.031c-19.603 0-40.078-1.229-55.79-4.452-4.71-5.305-7.07-11.128-7.069-16.952z",
    fill: "url(#paint30_linear)"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M177.214 244.628c1.976-11.901 7.595-44.572 7.595-44.572-.011 3.65 32.071 19.142 49.608 8.998 10.837-6.266 16.93-13.798 17.375-20.174v40.495l-.022.005c.451 3.016-.857 3.629.464 7.387 3.413 3.282 5.316 6.94 5.717 10.645a.17.17 0 01.009.014l-.007.003c.056.488.086.979.089 1.47-.002 6.031-3.981 12.063-11.937 16.664-15.915 9.205-41.718 9.205-57.633 0-7.958-4.601-11.936-10.634-11.936-16.666.005-1.45.234-2.89.678-4.269z",
    fill: "url(#paint31_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M180.543 224.96c2.114-12.371 4.266-24.904 4.266-24.904-.011 3.655 32.071 19.142 49.609 8.998 8.456-4.887 13.975-10.54 16.225-15.818l1.149.108v21.988l-34.988 30.024c-18.128-20.396-27.247-6.559-36.261-20.396z",
    fill: "url(#paint32_linear)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M278.165 188.88c0-10.974-2.013-21.316-5.569-30.396-8.142-20.786-77.848-20.912-86.024-.277-3.624 9.146-5.677 19.588-5.677 30.673 0 16.509 17.131 26.495 24.644 38.002 8.912 13.652 9.411 27.359 23.988 27.359 26.862 0 48.638-29.264 48.638-65.361z",
    fill: "url(#paint33_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M194.997 149.748c3.1-.159 6.402.916 9.837 3.857 17.869 15.292-5.724 47.44 6.419 60.994 12.057 13.457 13.862 37.513 21.207 39.441-.038.002-.077.039-.116.089a36.55 36.55 0 01-2.816.112c-14.578 0-15.077-13.707-23.989-27.359-7.513-11.507-24.644-21.493-24.644-38.001 0-11.086 2.053-21.527 5.677-30.674 1.338-3.377 4.331-6.194 8.425-8.459z",
    fill: "url(#paint34_linear)"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.452 201.353c13.052.489 26.387-2.152 36.362-7.922 9.188-5.313 12.867-12.279 13.789-19.246v-.01l.163.003a84.595 84.595 0 01.439 26.596c-1.396 5.794-5.891 11.387-13.597 15.844-6.416 3.71-14.193 6.157-22.396 7.339-15.873 2.287-23.53-7.482-24.515-14.619-.27-1.96-1.248-8.401 9.755-7.985z",
    fill: "url(#paint35_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M246.047 206.242c-1.574-3.192-5.069-3.98-7.847-1.768-2.787 2.222-3.751 6.601-2.199 9.786 1.56 3.182 5.07 3.976 7.849 1.761 2.793-2.213 3.75-6.598 2.197-9.779z",
    fill: "url(#paint36_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M277.603 188.939c-1.092-3.039-3.645-3.505-5.743-1.04-2.098 2.464-2.899 6.92-1.801 9.967 1.085 3.043 3.644 3.508 5.75 1.047 2.077-2.467 2.885-6.924 1.794-9.974z",
    fill: "url(#paint37_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M216.697 209.338c-.27-1.96-1.248-8.401 9.755-7.985a79.765 79.765 0 0017.072-1.282c9.074 4.243 13.831 13.248 13.923 19.515a68.528 68.528 0 01-16.235 4.371c-15.873 2.287-23.53-7.482-24.515-14.619z",
    fill: "url(#paint38_linear)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M272.704 184.567a23.93 23.93 0 003.899-10.382v-.01l.163.003a84.595 84.595 0 01.439 26.596c-.851 3.529-2.999 6.948-6.175 10.116 2.475-7.081 4.297-16.085 1.674-26.323z",
    fill: "#2E7E94"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M273.712 164.219c0-6.543-4.315-13.085-12.945-18.076-17.263-9.985-45.252-9.985-62.515 0-8.631 4.991-12.946 11.533-12.946 18.076-.001 6.543 4.315 13.086 12.946 18.078 17.263 9.983 45.252 9.983 62.515-.001 8.631-4.992 12.945-11.534 12.945-18.077z",
    fill: "#C2F2FE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M270.198 164.219c0-6.022-3.972-12.044-11.917-16.639-15.89-9.19-41.653-9.19-57.543 0-7.945 4.595-11.916 10.617-11.916 16.639-.001 6.022 3.971 12.045 11.916 16.64 15.89 9.189 41.653 9.189 57.544 0 7.945-4.595 11.916-10.618 11.916-16.64z",
    fill: "url(#paint39_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M193.146 271.31a3.871 3.871 0 00-3.507 0c-.97.56-.97 1.469 0 2.029a3.87 3.87 0 003.507 0c.969-.56.969-1.469 0-2.029zm7.881-11.159a4.356 4.356 0 00-1.964-3.408c-1.084-.627-1.963-.118-1.963 1.136a4.344 4.344 0 001.963 3.407c1.085.628 1.964.119 1.964-1.135z",
    fill: "#024455"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M191.393 273.271a.946.946 0 00.945-.947v-8.326l7.198-4.163a.95.95 0 00.346-1.293.956.956 0 00-.574-.441.952.952 0 00-.717.095l-7.67 4.436a.941.941 0 00-.472.819l-.001 8.873a.945.945 0 00.945.947z",
    fill: "url(#paint40_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M186.432 267.427a3.865 3.865 0 00-3.508 0c-.97.56-.97 1.468 0 2.028a3.871 3.871 0 003.508 0c.968-.56.968-1.468 0-2.028zm7.881-11.16a4.356 4.356 0 00-1.964-3.408c-1.085-.626-1.964-.118-1.964 1.137a4.337 4.337 0 001.964 3.407c1.085.627 1.964.119 1.964-1.136z",
    fill: "#024455"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M184.678 269.387a.942.942 0 00.945-.946v-8.327l7.198-4.163a.953.953 0 00.441-.574.958.958 0 00-.094-.719.941.941 0 00-.943-.465.946.946 0 00-.349.119l-7.67 4.436a.944.944 0 00-.472.82l-.001 8.873a.947.947 0 00.945.946z",
    fill: "url(#paint41_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M235.293 167.564a.458.458 0 01.625-.168l22.809 13.192c-.15.089-.292.182-.445.271-.154.089-.315.171-.471.258l-22.351-12.926a.446.446 0 01-.213-.279.446.446 0 01.046-.348zm-37.773-10.156l8.993 5.201a3.351 3.351 0 012.806.119 1.24 1.24 0 01.558 1.841 1.235 1.235 0 01-.558.457 3.323 3.323 0 01-3.058 0 1.36 1.36 0 01-.767-1.148c.004-.241.083-.475.227-.668l-8.553-4.946h-7.019c.139-.307.284-.613.445-.918h6.697c.08 0 .159.022.229.062zm9.2 6.824a2.407 2.407 0 002.141 0c.191-.111.31-.247.31-.354 0-.109-.119-.244-.31-.355a2.394 2.394 0 00-2.141 0c-.192.111-.31.246-.31.354 0 .109.118.244.31.355zm11.339-6.138a.462.462 0 01.169.627.452.452 0 01-.458.226.465.465 0 01-.169-.058l-9.574-5.538a3.351 3.351 0 01-2.806-.119 1.244 1.244 0 010-2.298 3.32 3.32 0 013.058 0 1.367 1.367 0 01.767 1.149 1.146 1.146 0 01-.227.667l9.24 5.344zm-10.238-6.365a2.401 2.401 0 00-2.142-.001c-.191.111-.309.247-.309.355 0 .108.118.244.309.354a2.398 2.398 0 002.142 0c.19-.11.309-.246.309-.354 0-.108-.119-.244-.309-.354zm18.805 6.307a.46.46 0 01-.626.168l-11.08-6.408a.464.464 0 01-.23-.398v-9.095c.305-.069.61-.135.917-.2v9.03l10.851 6.276c.052.03.098.071.135.118a.469.469 0 01.033.509zm2.325-2.788l-11.08-6.408a.451.451 0 01-.229-.398v-2.811a.462.462 0 01.229-.397l7.666-4.434a72.239 72.239 0 011.977-.084l-8.956 5.18v2.281l10.851 6.276a.46.46 0 01-.11.841.46.46 0 01-.348-.046zm-19.702 16.507l-7.231-4.182a3.345 3.345 0 01-1.416.247 3.342 3.342 0 01-1.39-.367 1.24 1.24 0 01-.557-1.84 1.24 1.24 0 01.557-.458 3.335 3.335 0 013.058 0 1.363 1.363 0 01.768 1.149 1.149 1.149 0 01-.227.668l6.667 3.855 17.192-9.943a.469.469 0 01.508.033.462.462 0 01.085.644.462.462 0 01-.135.118l-17.421 10.076a.462.462 0 01-.458 0zm-7.437-5.805a2.408 2.408 0 00-2.141 0c-.192.111-.31.246-.31.354 0 .109.118.245.31.355a2.407 2.407 0 002.141 0c.191-.11.31-.246.31-.355 0-.108-.119-.243-.31-.354zm5.605-7.326a.454.454 0 01-.626.168l-11.934-6.903c.232-.217.461-.436.707-.651l11.686 6.759a.458.458 0 01.167.627zm20.831 25.151a3.331 3.331 0 013.058 0c.266.148.484.369.627.638a59.182 59.182 0 004.034-.296l-4.146-2.398a.45.45 0 01-.214-.279.446.446 0 01.045-.348.465.465 0 01.627-.168l5.199 3.008a51.166 51.166 0 0012.178-3.101l-17.638-10.202a.457.457 0 01-.167-.627.458.458 0 01.625-.168l18.461 10.678a.456.456 0 01.228.425.455.455 0 01-.278.395 51.322 51.322 0 01-13.352 3.521 60.851 60.851 0 01-5.549.475 1.533 1.533 0 01-.68.746 3.334 3.334 0 01-3.058 0 1.244 1.244 0 010-2.299zm.458 1.504a2.41 2.41 0 002.141 0c.192-.111.311-.246.311-.354 0-.109-.119-.244-.311-.354a2.409 2.409 0 00-1.07-.253c-.372 0-.738.087-1.071.252-.191.111-.309.246-.309.355 0 .108.118.244.309.354zm-21.463-5.862a3.352 3.352 0 012.807-.12l15.914-9.204a.46.46 0 01.626.168.464.464 0 01-.167.627l-8.263 4.778v2.896c.376.043.74.158 1.071.341a1.242 1.242 0 010 2.298 3.335 3.335 0 01-3.058 0 1.242 1.242 0 010-2.298 2.891 2.891 0 011.071-.341v-2.366l-6.402 3.703c.143.193.223.426.227.667a1.372 1.372 0 01-.768 1.149 3.335 3.335 0 01-3.058 0 1.242 1.242 0 010-2.298zm9.388.281c-.191.11-.309.246-.309.354 0 .108.118.244.309.354a2.398 2.398 0 002.142 0c.19-.11.309-.246.309-.354 0-.108-.119-.244-.309-.354a2.202 2.202 0 00-1.064-.252l-.007.002-.008-.002a2.19 2.19 0 00-1.063.252zm-8.93 1.222a2.398 2.398 0 002.142 0c.191-.11.309-.246.309-.354 0-.108-.118-.244-.309-.354a2.398 2.398 0 00-2.142-.001c-.19.111-.309.247-.309.355 0 .108.119.244.309.354zm48.216-8.072h-4.622a.463.463 0 01-.23-.061l-11.988-6.934a.462.462 0 01-.169-.627.459.459 0 01.626-.168l11.883 6.872h4.377l5.186-2.999a1.152 1.152 0 01-.226-.667 1.365 1.365 0 01.767-1.149 3.332 3.332 0 013.058 0 1.242 1.242 0 010 2.298 3.352 3.352 0 01-2.807.12l-5.626 3.254a.462.462 0 01-.229.061zm6.062-4.23a2.398 2.398 0 002.142 0c.19-.11.309-.246.309-.354 0-.108-.119-.244-.309-.354a2.401 2.401 0 00-2.142 0c-.191.11-.309.246-.309.354 0 .109.118.244.309.354zm-39.078-1.326a.465.465 0 01.348-.046.462.462 0 01.244.723.446.446 0 01-.134.118l-11.9 6.882a.463.463 0 01-.229.062h-17.867a21.798 21.798 0 01-.783-.918h18.527l11.794-6.821zm29.433-5.415h-8.787a.46.46 0 010-.918h8.664l13.314-7.701c.213.234.41.472.608.709l-13.57 7.848a.463.463 0 01-.229.062zm-7.319-12.027a1.362 1.362 0 01-.768 1.149 3.323 3.323 0 01-3.057 0 1.237 1.237 0 01-.767-1.149 1.24 1.24 0 01.767-1.149 3.35 3.35 0 012.806-.12l7.314-4.229c.37.136.739.277 1.104.421l-7.626 4.41c.144.193.223.426.227.667zm-1.225-.354a2.401 2.401 0 00-2.142 0c-.191.11-.31.246-.31.354 0 .109.119.244.31.354a2.398 2.398 0 002.142 0c.19-.11.309-.246.309-.354 0-.108-.119-.244-.309-.354zM235.483 153a.46.46 0 11-.917 0v-5.447a.464.464 0 01.23-.397l8.703-5.034c.445.094.89.188 1.33.29l-9.346 5.406V153zm19.314 1.74h-8.767l-8.015 4.636a.46.46 0 11-.458-.795l17.422-10.076a.457.457 0 01.457.795l-7.819 4.522h7.056l6.969-4.03c.269.199.539.398.794.601l-7.411 4.286a.455.455 0 01-.228.061zm-16.171 22.023a.456.456 0 01-.228.398l-2.912 1.684a.46.46 0 11-.458-.795l2.224-1.287-7.972-4.61a.458.458 0 01.459-.795l8.659 5.008a.456.456 0 01.228.398v-.001z",
    fill: "url(#paint42_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M219.009 154.281h10.501l-17.184 9.938 17.184 9.939h-10.501l-17.184-9.939 17.184-9.938z",
    fill: "url(#paint43_linear)"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M246.693 158.146l-17.183 9.939v6.073l17.183-9.939v-6.073z",
    fill: "#CEEFF8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M229.51 168.085l-17.185-9.939v6.073l17.185 9.939v-6.073z",
    fill: "#BBDDE6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M229.51 147.636l-16.278 9.414 16.278 9.414 16.277-9.414-16.277-9.414z",
    fill: "#C2F2FE"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M221.642 165.42l-1.448-.837v4.187l1.448.837v-4.187zM217.812 163.205l-1.447-.837v4.187l1.447.838v-4.188zM225.471 167.634l-1.449-.838v4.188l1.449.837v-4.187z",
    fill: "#A5C4CC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M237.377 165.42l1.448-.837v4.187l-1.448.837v-4.187zM241.206 163.205l1.449-.837v4.187l-1.449.838v-4.188zM233.548 167.634l1.449-.838v4.188l-1.449.837v-4.187z",
    fill: "#BBDDE6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M246.693 158.146l-.906-1.096-16.277 9.414v1.621l17.183-9.939z",
    fill: "#E8F4F7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M229.51 166.464v1.621l-17.185-9.939.907-1.096 16.278 9.414z",
    fill: "#CEEFF8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M81.141 318.152l8.438-4.88a3.123 3.123 0 00-1.113 2.315h-.003v5.66h.002c.015 1.098.74 2.192 2.18 3.024l46.421 26.848c1.442.833 3.34 1.253 5.24 1.261v.001h-9.67v-.006a10.694 10.694 0 01-5.072-1.256l-46.423-26.848c-2.91-1.682-2.91-4.436 0-6.119z",
    fill: "url(#paint44_linear)"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M90.644 318.606l46.423 26.848c2.909 1.683 7.671 1.683 10.58 0l26.981-15.604c1.442-.834 2.168-1.931 2.18-3.032h.001v5.66h-.001c-.009 1.102-.735 2.202-2.18 3.037l-26.981 15.604c-2.909 1.683-7.671 1.683-10.58 0l-46.423-26.848c-1.44-.832-2.164-1.926-2.18-3.024h-.001v-5.66h.002c.018 1.096.742 2.188 2.18 3.019z",
    fill: "url(#paint45_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M90.644 312.487c-2.91 1.683-2.91 4.436 0 6.12l46.423 26.847c2.909 1.683 7.671 1.683 10.58 0l26.981-15.604c2.909-1.682 2.909-4.436 0-6.119l-46.422-26.848c-2.91-1.682-7.672-1.682-10.581 0l-26.98 15.604z",
    fill: "#F4F8F9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M90.644 312.487l9.832-5.686h8.555l-4.897 2.832 48.291 28.019h-28.849l-32.932-19.046c-2.91-1.683-2.91-4.436 0-6.119z",
    fill: "url(#paint46_linear)"
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M157.321 291.196l-4.896 2.833v43.623l4.896-2.833v-43.623z",
    fill: "#BBDAE2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M152.425 283.681l-48.291-28.019v53.971l48.291 28.019v-53.971z",
    fill: "#93BECA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M109.956 227.164a4.247 4.247 0 015.372-1.103l56.374 32.603a3.19 3.19 0 01.977 4.775l-31.557 42.211a4.244 4.244 0 01-5.371 1.102L79.376 274.15a3.185 3.185 0 01-1.575-3.536c.107-.451.311-.874.598-1.238l31.557-42.212z",
    fill: "#F4F8F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M135.751 306.753a4.247 4.247 0 005.371-1.103l31.557-42.211a3.174 3.174 0 00-.097-4.052l3.992 4.727h-.001a3.174 3.174 0 01.151 4.113l-31.557 42.21a4.243 4.243 0 01-5.372 1.104l-56.374-32.603a3.411 3.411 0 01-1.04-.922h-.001l-3.801-4.499c.233.249.501.463.797.633l56.375 32.603z",
    fill: "url(#paint47_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M138.104 304.663l31.977-42.773-57.061-33.799-32.254 43.142 57.338 33.43z",
    fill: "url(#paint48_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.41 259.297c5.259-7.152 15.245-13.791 24.213-9.054l-2.792 3.734c-6.865-3.543-14.525 1.671-18.532 7.099-2.653 3.593-4.088 7.449-4.124 10.701-1.662.628-2.488.935-4.126 1.531-.025-4.193 1.871-9.267 5.361-14.011z",
    fill: "#F77D48"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.411 272.231c5.325-7.123 5.423-15.175.42-18.254l2.792-3.734c8.374 5.632 4.599 17.294-.322 23.767-4.644 6.109-12.213 11.552-20.355 10.249.702-1.555 1.074-2.36 1.845-4.007 4.886.89 11.207-2.118 15.62-8.021z",
    fill: "#69C5DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.049 273.308c1.638-.596 2.464-.903 4.126-1.531-.036 3.251 1.266 5.93 3.787 7.44a8.383 8.383 0 002.829 1.035 267.981 267.981 0 00-1.845 4.007 11.747 11.747 0 01-3.713-1.391c-3.337-1.977-5.161-5.368-5.184-9.56z",
    fill: "#BBDAE2"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M157.945 260.616l6.59 3.993.941-1.257-6.603-3.978-.928 1.242zm-2.001 2.676l6.572 4.02c.395-.529.59-.792.978-1.31-2.632-1.605-3.947-2.405-6.579-4.008-.385.514-.578.775-.971 1.298zm1.203 4.795c1.312.807 1.969 1.21 3.279 2.019.408-.544.61-.815 1.01-1.352-1.312-.806-1.969-1.208-3.281-2.015l-1.008 1.348z",
    fill: "#F5F8F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M121.296 248.337a.405.405 0 00.406-.405 137.91 137.91 0 00-.045-4.732l-.006-.222-7.721-4.732a.41.41 0 00-.559.136.406.406 0 00.019.452c.031.044.071.08.116.108l7.343 4.5c.041 1.73.047 2.673.04 4.486a.402.402 0 00.25.378c.049.02.102.031.156.031h.001zM99.73 272.385l.179-.064a234.142 234.142 0 004.897-1.765.399.399 0 00.229-.211.416.416 0 00.013-.312.4.4 0 00-.211-.229.414.414 0 00-.312-.012 243.39 243.39 0 01-4.706 1.698l-7.433-4.434a.405.405 0 00-.557.143.408.408 0 00.141.558l7.76 4.628zm37.562 22.334a.41.41 0 00.377-.56.404.404 0 00-.169-.198l-7.407-4.417a127.39 127.39 0 01-.113-4.384.406.406 0 00-.406-.403h-.005a.41.41 0 00-.402.412c.022 1.841.044 2.77.122 4.63l.01.219 7.784 4.643a.406.406 0 00.209.058z",
    fill: "#7ED8F1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M112.122 256.336c5.259-7.152 15.246-13.789 24.214-9.052l-2.791 3.734c-6.866-3.544-14.526 1.67-18.534 7.098-2.652 3.592-4.088 7.451-4.123 10.703-1.661.626-2.488.934-4.127 1.53-.024-4.195 1.872-9.268 5.361-14.013z",
    fill: "#F77D48"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M133.124 269.272c5.325-7.124 5.424-15.177.421-18.254l2.791-3.734c8.374 5.63 4.599 17.293-.323 23.766-4.643 6.109-12.212 11.551-20.355 10.248a277.92 277.92 0 011.846-4.006c4.885.891 11.207-2.119 15.62-8.02z",
    fill: "#69C5DF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M106.761 270.349c1.639-.596 2.465-.904 4.127-1.53-.036 3.248 1.266 5.928 3.788 7.438a8.378 8.378 0 002.828 1.035 277.92 277.92 0 00-1.846 4.006 11.721 11.721 0 01-3.713-1.39c-3.337-1.978-5.16-5.368-5.184-9.559z",
    fill: "#F0F3F4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M80.766 271.233l57.338 33.43 31.977-42.773a535066.488 535066.488 0 01-57.061-33.799c-10.751 14.382-21.502 28.762-32.254 43.142z",
    fill: "#2E7D93"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M108.266 234.449l57.082 33.773 4.733-6.332a535066.488 535066.488 0 01-57.061-33.799l-4.754 6.358z",
    fill: "#DAEFF5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M165.424 262.036l-5.697-3.374-1.584 2.12 5.698 3.373c.646-.867.964-1.291 1.583-2.119z",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M99.765 265.881l1.646.962c.522-.692.786-1.039 1.317-1.74l-1.647-.965-1.316 1.743zm-3.063-1.792l1.618.947 1.316-1.744-1.62-.947-1.314 1.744zm-3.006-1.756l1.587.927 1.315-1.746-1.588-.929-1.314 1.748z",
    fill: "#7CDFFB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M147.309 266.753a.329.329 0 01.16.303.566.566 0 01-.434.521l-2.934.613.641 2.698a.542.542 0 01-.33.582.395.395 0 01-.37-.006.31.31 0 01-.15-.206l-.757-3.203a.469.469 0 01.084-.38.554.554 0 01.34-.232l3.477-.725a.371.371 0 01.273.035zm5.085 2.968a.304.304 0 01.099.09.329.329 0 01.053.123l.761 3.198a.49.49 0 01-.088.379.56.56 0 01-.336.233l-3.484.727a.373.373 0 01-.268-.036.344.344 0 01-.162-.306.562.562 0 01.131-.332.562.562 0 01.303-.189l2.934-.612-.641-2.699a.549.549 0 01.515-.624.393.393 0 01.183.048zm-2.372-3.45a.371.371 0 01.128.474l-3.064 7.862a.537.537 0 01-.568.351.322.322 0 01-.099-.038.38.38 0 01-.131-.48l3.06-7.857a.541.541 0 01.569-.352.326.326 0 01.105.04zm-22.497 8.978a.322.322 0 01.122.129.326.326 0 01.039.173.574.574 0 01-.434.521l-2.935.613.641 2.699a.537.537 0 01-.329.581.402.402 0 01-.371-.005.322.322 0 01-.15-.207l-.757-3.202a.465.465 0 01.084-.381.549.549 0 01.34-.231l3.478-.725a.364.364 0 01.272.035zm5.085 2.967a.328.328 0 01.153.213l.761 3.198a.513.513 0 01-.005.199.519.519 0 01-.083.18.56.56 0 01-.336.233l-3.485.727a.37.37 0 01-.267-.036.337.337 0 01-.163-.306.57.57 0 01.434-.521l2.935-.612-.641-2.699a.549.549 0 01.514-.623.39.39 0 01.183.047zm-2.372-3.45a.37.37 0 01.128.474l-3.063 7.862a.542.542 0 01-.569.352.376.376 0 01-.098-.038.38.38 0 01-.132-.48l3.06-7.857a.542.542 0 01.57-.352c.037.007.072.02.104.039z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M110.808 255.178c5.429 3.201 17.755 10.506 23.184 13.707.195-.26 1.018-1.406 1.181-1.57-5.425-3.205-17.749-10.508-23.174-13.713l-1.191 1.576z",
    fill: "url(#paint49_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M103.622 269.567c5.429 3.201 8.574 5.074 14.002 8.276.196-.26 1.018-1.407 1.182-1.571-5.425-3.204-8.568-5.076-13.993-8.281l-1.191 1.576z",
    fill: "url(#paint50_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M101.05 273.008c5.43 3.201 8.574 5.074 14.003 8.275.195-.26 1.018-1.407 1.181-1.57-5.425-3.205-8.568-5.076-13.992-8.281l-1.192 1.576z",
    fill: "url(#paint51_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M112.756 244.126c3.431 2.027 11.377 6.732 18.127 10.727l-1.178 1.576c-6.754-3.995-14.705-8.701-18.141-10.727l1.192-1.576zm27.561 16.308c-.164.164-.986 1.31-1.182 1.57-1.575-.929-4.103-2.423-7.027-4.153l1.179-1.575 7.03 4.158z",
    fill: "url(#paint52_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M137.745 263.874c-.164.164-.986 1.311-1.182 1.571-2.577-1.52-7.699-4.55-12.949-7.657l1.179-1.577c5.251 3.108 10.375 6.141 12.952 7.663zm-27.561-16.307c2.454 1.45 7.221 4.271 12.205 7.222l-1.179 1.577c-4.989-2.952-9.759-5.774-12.217-7.223l1.191-1.576z",
    fill: "url(#paint53_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M105.401 258.416c3.001 1.773 6.698 3.963 10.321 6.108l-1.179 1.576a7415.272 7415.272 0 00-10.333-6.108l1.191-1.576zm18.548 10.975c-.163.164-.986 1.311-1.181 1.571a4512.734 4512.734 0 01-5.82-3.439l1.178-1.576c2.076 1.228 4.069 2.408 5.823 3.444z",
    fill: "url(#paint54_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M102.83 261.856l6.458 3.821-1.18 1.578c-2.308-1.365-4.534-2.682-6.47-3.823l1.192-1.576zm18.548 10.975c-.164.164-.986 1.311-1.182 1.571-2.826-1.667-6.267-3.703-9.683-5.724l1.178-1.578c3.418 2.024 6.86 4.062 9.687 5.731z",
    fill: "url(#paint55_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M147.309 265.7a.322.322 0 01.122.129.325.325 0 01.038.173.566.566 0 01-.434.522l-2.934.612.641 2.699a.548.548 0 01-.064.348.545.545 0 01-.266.233.409.409 0 01-.185.043.41.41 0 01-.185-.048.316.316 0 01-.15-.207l-.757-3.202a.465.465 0 01.084-.38.546.546 0 01.34-.232l3.477-.725a.366.366 0 01.273.035zm5.085 2.967a.328.328 0 01.099.09.329.329 0 01.053.123l.761 3.198a.494.494 0 01-.088.379.555.555 0 01-.336.233l-3.484.728a.369.369 0 01-.268-.037.334.334 0 01-.162-.305.567.567 0 01.434-.522l2.934-.611-.641-2.7a.545.545 0 01.33-.581.395.395 0 01.368.005zm-2.372-3.45a.369.369 0 01.128.474l-3.064 7.862a.54.54 0 01-.568.352.35.35 0 01-.099-.038.378.378 0 01-.131-.48l3.06-7.857a.541.541 0 01.569-.352c.037.007.073.02.105.039zm-22.497 8.978a.329.329 0 01.122.129.328.328 0 01.039.174.57.57 0 01-.434.521l-2.935.612.641 2.699a.541.541 0 01-.329.582.401.401 0 01-.371-.006.33.33 0 01-.15-.206l-.757-3.203a.46.46 0 01.084-.38.554.554 0 01.34-.232l3.478-.725a.368.368 0 01.272.035zm5.085 2.967a.32.32 0 01.153.214l.761 3.197a.513.513 0 01-.005.199.519.519 0 01-.083.18.562.562 0 01-.336.234l-3.485.727a.37.37 0 01-.267-.036.343.343 0 01-.163-.306.574.574 0 01.434-.521l2.935-.612-.641-2.699a.542.542 0 01.329-.582.398.398 0 01.368.005zm-2.372-3.449a.369.369 0 01.128.473l-3.063 7.862a.535.535 0 01-.569.352.317.317 0 01-.098-.038.377.377 0 01-.132-.48l3.06-7.857a.546.546 0 01.57-.352.32.32 0 01.104.04z",
    fill: "#00C0F3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M110.808 254.124c5.429 3.201 17.755 10.506 23.184 13.708.195-.26 1.018-1.407 1.181-1.571-5.425-3.205-17.749-10.508-23.174-13.713l-1.191 1.576zM103.622 268.514c5.429 3.2 8.574 5.074 14.002 8.275.196-.26 1.018-1.407 1.182-1.571-5.425-3.204-8.568-5.075-13.993-8.28l-1.191 1.576zM101.05 271.954c5.43 3.201 8.574 5.074 14.003 8.276.195-.26 1.018-1.407 1.181-1.571-5.425-3.204-8.568-5.076-13.992-8.281l-1.192 1.576zm11.706-28.881c3.431 2.027 11.376 6.731 18.127 10.727l-1.178 1.576c-6.754-3.996-14.705-8.702-18.141-10.727l1.192-1.576zm27.561 16.307c-.164.164-.986 1.311-1.182 1.571l-7.027-4.153 1.179-1.576c2.925 1.731 5.454 3.228 7.03 4.158z",
    fill: "#F77D48"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M137.745 262.82c-.164.164-.986 1.311-1.182 1.571-2.577-1.52-7.699-4.55-12.949-7.657l1.179-1.576c5.251 3.107 10.375 6.14 12.952 7.662zm-27.561-16.307c2.454 1.451 7.221 4.271 12.205 7.222l-1.179 1.577c-4.989-2.952-9.759-5.774-12.217-7.223l1.191-1.576z",
    fill: "#00C0F3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M105.401 257.362c3.001 1.773 6.698 3.963 10.321 6.108l-1.179 1.577c-3.626-2.146-7.327-4.337-10.333-6.109l1.191-1.576zm18.548 10.975c-.163.164-.986 1.311-1.181 1.571a3594.392 3594.392 0 01-5.82-3.439l1.178-1.576c2.076 1.229 4.069 2.408 5.823 3.444z",
    fill: "#57CCEC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M102.83 260.803c1.932 1.141 4.154 2.457 6.458 3.82l-1.18 1.578c-2.308-1.364-4.534-2.681-6.47-3.822l1.192-1.576zm18.548 10.975c-.164.164-.986 1.31-1.182 1.57-2.826-1.666-6.267-3.703-9.683-5.724l1.178-1.577c3.418 2.023 6.86 4.062 9.687 5.731z",
    fill: "#F77D48"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M62.577 350.262h33.626v6.19H62.577v-6.19z",
    fill: "url(#paint56_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.416 341.322h33.626v6.19H47.416v-6.19z",
    fill: "url(#paint57_linear)"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M77.32 345.608c0-4.864 3.078-5.004 3.078-5.004s1.666 0 4.373-1.126c2.67-1.111 6.435-.681 4.33 3.206a1.04 1.04 0 01-.072.143 1.88 1.88 0 01-.682.599l-6.722 3.951c-1.025.587-4.28-.768-4.304-1.769z",
    fill: "url(#paint58_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M77.339 345.172c.058.999 3.269 2.327 4.285 1.746l6.723-3.95c.337-.2.655-.432.949-.692-.063.134-.117.262-.195.408-.02.049-.044.097-.072.143a1.88 1.88 0 01-.682.599l-6.722 3.951c-.96.549-3.876-.604-4.261-1.576a1.035 1.035 0 01-.03-.197 3.261 3.261 0 01.005-.432z",
    fill: "#024455"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M78.572 339.965c.792 0 3.58.71 3.58.71.023.258.109.506.25.723.028.031.052.062.077.094.552.383 1.111.99-.195 1.811a1.806 1.806 0 01-2.35-.168 2.147 2.147 0 00-.757-.861 1.923 1.923 0 00-.729-.307.371.371 0 00-.006-.067s-.202-1.935.13-1.935z",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M78.523 292.412c3.04.054 10.637.189 13.675.245-1.13 9.154-3.406 17.466-4.928 26.33-1.63 8.616-3.47 14.67-5.075 21.839-.587 1.336-3.275.832-3.821-.454-.425-6.603-.914-14.647 1.04-22.265-.327-8.212-1.083-17.405-.891-25.695z",
    fill: "#024455"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M92.646 354.543c0-4.863 3.078-5.004 3.078-5.004s1.665 0 4.373-1.124c2.669-1.112 6.434-.683 4.329 3.205-.02.049-.044.097-.072.143a1.856 1.856 0 01-.682.599l-6.723 3.951c-1.023.587-4.279-.77-4.303-1.77z",
    fill: "url(#paint59_linear)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M92.665 354.107c.058 1 3.269 2.328 4.284 1.746l6.723-3.949c.337-.2.655-.432.949-.691-.063.133-.117.261-.195.407a.911.911 0 01-.072.143 1.856 1.856 0 01-.682.599l-6.723 3.952c-.958.548-3.875-.605-4.26-1.577a1.077 1.077 0 01-.03-.197 3.177 3.177 0 01.006-.433z",
    fill: "#024455"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M93.898 348.9c.791 0 3.581.71 3.581.71.022.258.107.507.248.724.028.031.051.062.078.094.55.384 1.11.99-.195 1.811a1.811 1.811 0 01-2.35-.168 2.153 2.153 0 00-.76-.861 1.97 1.97 0 00-.726-.309.389.389 0 00-.007-.065s-.202-1.936.13-1.936z",
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M88.169 314.176c-.833-3.935-10.418-4.424-9.788-19.895 3.007-.443 18.18 6.685 21.186 6.241.376 9.216-.513 17.79-.57 26.784-.203 8.766-1.03 15.038-1.446 22.377-.362 1.412-3.096 1.354-3.843.176-1.496-6.444-3.29-14.302-2.604-22.136-.897-4.34-1.962-8.94-2.935-13.547z",
    fill: "url(#paint60_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M85.316 264.238c-10.703 7.164-11.979 21.391-6.192 30.421 0 0-1.244-20.006 6.192-30.421z",
    fill: "url(#paint61_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M84.827 303.053c6.515 3.661 13.331 3.669 15.655-.833-.87-8.384-1.683-15.206-.006-23.239-.497-4.438-.844-5.104-.276-7.693-.202-.868-2.865-2.719-4.807-4.495-2.099-1.919-3.515-3.743-4.594-3.963-8.91-1.822-13.238 14.08-12.492 31.033.687 4.508 3.313 7.386 6.52 9.19z",
    fill: "url(#paint62_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M85.858 263.841c1.932-1.398 1.646-2.313 1.356-4.217a9.464 9.464 0 01-.582-3.286c0-4.24 2.695-7.903 5.999-7.676 6.657.458 5.472 3.967 5.472 8.207 0 3.927-1.777 6.631-4.752 7.086 0 .644.17 1.015.98 1.827-2.173 1.305-5.348.69-6.602.122-1.336-.604-2.778-1.123-1.871-2.063zm24.263 10.173l-.012.037c0-1.674.35-2.648.993-2.933.138-.4.285-.818.427-1.217.832-2.334 3.441-4.336 3.996-3.779.334.335-.993 1.361-1.693 2.473-.462.734-.465 1.14-.583 1.752 0 0 3.121.292 3.121 2.89 0 2.113-1.137 1.278-1.137.861-.806 2.141-1.762.876-2.133 2.62l-3.378-1.496s.158-.484.399-1.208z",
    fill: "#FCD1A9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M89.706 247.589c.858-.442 1.63-.214 2.11-.521 1.137-.697 2.214-1.141 2.816-.81.3.2.583.426.846.674.592.592 1.805-.67 2.097.862.074.392.108.791.1 1.19 2.843.365 1.444 2.959-.84 7.954-.004-.811-1.723-2.685-1.723.918 0 .388.289.463.035.977-.255.513-1.889 1.805-2.966 2.884-1.504 1.507-2.388.155-4.873.426a3.98 3.98 0 00-.655-2.27c-.238-.422-1.603-1.763-1.604-4.103 1.93.237-1.5-5.003 4.657-8.181z",
    fill: "#31788C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 271.288c.838 3.322 1.533 8.622 1.799 11.658 2.724-2.84 5.228-4.081 7.587-7.854l3.853 1.61c-.726 2.637-7.867 13.483-12.957 14.282-4.976-1.868-5.921-11.023-6.657-14.948-1.08-5.747 5.144-8.059 6.375-4.748z",
    fill: "url(#paint63_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M249.936 93.216l2.994-4.248c-6.893-8.604-9.244-20.17-5.253-25.834l-5.169-6.452c-5.645 8.01-2.32 24.366 7.428 36.534z",
    fill: "url(#paint64_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M249.936 93.216l2.994-4.248c-6.893-8.604-9.244-20.17-5.253-25.834l-5.169-6.452c-5.645 8.01-2.32 24.366 7.428 36.534z",
    fill: "#57CCEC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M247.677 63.135c3.992-5.664 12.816-3.282 19.709 5.322 4.239 5.291 6.751 11.699 7.136 17.168.241 3.425-.347 6.485-1.884 8.666-2.552 3.622-7.082 3.939-11.818 1.457-2.67-1.4-5.405-3.678-7.89-6.78l-2.994 4.248c3.514 4.387 7.382 7.61 11.158 9.588 6.698 3.51 13.104 3.062 16.713-2.06 2.174-3.085 3.006-7.411 2.665-12.255-.545-7.736-4.098-16.798-10.092-24.28-9.748-12.167-22.226-15.537-27.872-7.527l5.169 6.453z",
    fill: "#BBDDE6"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M263.072 77.367c.199-.17.56-.007.808.365l3.585 5.38c.132.189.206.411.215.641a.379.379 0 01-.214.393l-3.587 1.232c-.248.085-.608-.17-.807-.57-.197-.4-.157-.791.09-.878l3.025-1.04-3.025-4.54c-.247-.371-.288-.81-.09-.983zm-12.103-3.795l3.586-1.233c.247-.085.607.169.807.57.197.4.157.792-.09.878l-3.026 1.04 3.026 4.54c.248.372.287.81.09.982-.198.17-.56.008-.807-.363l-3.587-5.381a1.218 1.218 0 01-.215-.642.38.38 0 01.216-.391zm7.366-1.193l2.869 13.233c.086.403-.091.666-.394.591a1.175 1.175 0 01-.71-.864l-2.869-13.234c-.087-.403.089-.667.394-.59a1.173 1.173 0 01.71.864z",
    fill: "#00C0F3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M276.645 97.323v6.91c7.965 4.606 14.422 15.809 14.422 25.023l5.974 3.454c0-13.029-9.132-28.872-20.396-35.387z",
    fill: "url(#paint65_linear)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M276.645 97.323v6.91c7.965 4.606 14.422 15.809 14.422 25.023l5.974 3.454c0-13.029-9.132-28.872-20.396-35.387zM276.645 104.233v-6.91c-4.061-2.349-7.836-3.142-11.014-2.614l3.226 7.675c2.247-.374 4.916.188 7.788 1.849z",
    fill: "#00C0F3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M291.067 129.255c0 9.214-6.457 12.948-14.422 8.341-4.899-2.832-9.22-8.163-11.826-13.987l-4.898 1.115c3.686 8.238 9.797 15.776 16.724 19.782 11.264 6.515 20.396 1.234 20.396-11.796l-5.974-3.455z",
    fill: "url(#paint66_linear)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M262.222 112.573c0-5.891 2.648-9.527 6.635-10.189l-3.226-7.675c-5.639.935-9.382 6.078-9.382 14.41 0 5.016 1.363 10.447 3.672 15.605l4.898-1.115c-1.632-3.648-2.597-7.488-2.597-11.036z",
    fill: "#DAEFF5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M276.351 121.567c-.58-.338-1.128-.395-1.539-.159-.412.236-.641.737-.644 1.41a4.84 4.84 0 002.163 3.789c1.198.699 2.179.137 2.184-1.252l1.972 1.151c-.009 2.255-1.365 3.361-3.178 2.819l-.007 1.804-1.972-1.152.008-1.803c-1.809-1.571-3.15-4.251-3.142-6.507.005-1.284.441-2.239 1.228-2.689.786-.451 1.829-.343 2.936.303 1.198.699 2.178.138 2.184-1.251a4.843 4.843 0 00-2.164-3.789c-1.198-.699-2.178-.137-2.183 1.252l-1.972-1.15c.009-2.256 1.365-3.361 3.177-2.82l.007-1.664 1.971 1.151-.006 1.663c1.809 1.573 3.15 4.252 3.141 6.508-.01 2.649-1.878 3.72-4.164 2.386z",
    fill: "#317B8F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M72.376 199.992c6.023 3.484 10.906.659 10.906-6.308s-4.883-15.438-10.906-18.922c-4.912-2.84-9.064-1.486-10.43 2.888l-5.352-4.991c2.066-6.619 8.35-8.668 15.782-4.37 9.114 5.271 16.503 18.09 16.503 28.632 0 10.543-7.39 14.815-16.504 9.544a28.662 28.662 0 01-6.604-5.415l2.24-4.637a18.964 18.964 0 004.365 3.579z",
    fill: "#55AEC6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M88.879 196.921c0-10.542-7.39-23.361-16.504-28.632-4.603-2.663-8.766-2.887-11.759-1.1v-.001l2.355-1.363.002.001c2.993-1.787 7.154-1.563 11.759 1.1 9.114 5.271 16.503 18.09 16.503 28.632 0 5.265-1.843 8.965-4.823 10.695l-.008.005-.007.004-2.34 1.354h-.001c2.98-1.73 4.823-5.431 4.823-10.695z",
    fill: "url(#paint67_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M65.941 173.476a6.749 6.749 0 00-1.639 2.812l-2.356 1.362c.696-2.229 2.12-3.669 3.995-4.174zm4.426 21.574a18.925 18.925 0 004.365 3.579c2.41 1.394 4.637 1.775 6.442 1.288-1.984 1.982-5.186 2.164-8.799.075a19 19 0 01-4.365-3.579l2.357-1.363z",
    fill: "#317B8F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M61.946 177.651l2.356-1.363a11.472 11.472 0 00-.476 3.419c0 5.171 2.691 11.169 6.541 15.344l-2.357 1.362c-3.85-4.174-6.54-10.172-6.54-15.344-.015-1.157.146-2.31.476-3.418z",
    fill: "#0096BF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M61.946 177.65a11.476 11.476 0 00-.477 3.419c0 5.172 2.691 11.17 6.542 15.344l-2.24 4.637c-5.826-6.316-9.898-15.393-9.898-23.217a17.386 17.386 0 01.72-5.174l5.353 4.991z",
    fill: "#57CCEC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M34.151 260.087a4.776 4.776 0 012.345-.562h23.388v3.834H36.496a4.786 4.786 0 01-2.345-.561c-.647-.375-.97-.865-.97-1.356 0-.49.323-.981.97-1.355z",
    fill: "url(#paint68_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.536 254.943a4.776 4.776 0 012.344-.562h23.388v3.834H20.88a4.787 4.787 0 01-2.344-.561c-.647-.375-.97-.865-.97-1.356 0-.491.323-.981.97-1.355z",
    fill: "url(#paint69_linear)"
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M47.776 238.747v17.551c0 .491-.324.981-.97 1.356a5.175 5.175 0 01-4.688 0c-.648-.375-.972-.865-.972-1.356v-17.551h6.63z",
    fill: "url(#paint70_linear)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M46.805 237.391a5.175 5.175 0 00-4.687 0c-.648.374-.972.865-.972 1.356 0 .49.325.981.972 1.355a5.175 5.175 0 004.687 0c.647-.374.97-.865.97-1.355 0-.491-.323-.982-.97-1.356z",
    fill: "#EAF6F9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M37.204 265.934a4.786 4.786 0 012.344-.561h12.37v3.833h-12.37a4.786 4.786 0 01-2.344-.561c-.647-.375-.97-.865-.97-1.356 0-.49.323-.981.97-1.355z",
    fill: "url(#paint71_linear)"
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M55.425 257.915v9.374c0 .491-.324.981-.97 1.356a5.175 5.175 0 01-4.688 0c-.647-.375-.97-.865-.97-1.356v-9.374h6.628z",
    fill: "url(#paint72_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M54.454 256.56a5.175 5.175 0 00-4.687 0c-.647.375-.97.865-.97 1.355 0 .491.323.982.97 1.356a5.175 5.175 0 004.687 0c.647-.374.97-.865.97-1.356 0-.49-.323-.98-.97-1.355z",
    fill: "#F3B378"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M63.39 245.978v15.464c0 .491-.323.981-.97 1.356a5.174 5.174 0 01-4.687 0c-.648-.375-.971-.865-.971-1.356v-15.464h6.629z",
    fill: "url(#paint73_linear)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M62.42 244.622a5.174 5.174 0 00-4.687 0c-.648.375-.971.865-.971 1.356 0 .49.323.981.97 1.355a5.175 5.175 0 004.688 0c.647-.374.97-.865.97-1.355 0-.491-.323-.981-.97-1.356z",
    fill: "#7FDBF4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.801 271.078a4.784 4.784 0 012.344-.561h23.388v3.833H44.145a4.787 4.787 0 01-2.344-.561c-.647-.374-.97-.865-.97-1.355 0-.491.323-.981.97-1.356z",
    fill: "url(#paint74_linear)"
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M71.04 258.215v14.219c0 .49-.323.98-.97 1.355a5.175 5.175 0 01-4.688 0c-.647-.375-.97-.865-.97-1.355v-14.219h6.628z",
    fill: "url(#paint75_linear)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M70.07 256.859a5.175 5.175 0 00-4.688 0c-.647.374-.97.865-.97 1.356 0 .49.323.981.97 1.355a5.162 5.162 0 004.688 0c.647-.374.97-.865.97-1.355 0-.491-.323-.982-.97-1.356z",
    fill: "#EAF6F9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M367.92 345.904h43.073l-3.33 7.316H367.92v-7.316z",
    fill: "url(#paint76_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M377.682 336.267h40.132l-.388 4.654h-39.744v-4.654z",
    fill: "url(#paint77_linear)"
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M420.446 329.475c1.34-.914 3.454.642 3.988 2.37.023.745-.528 1.989-.528 1.989s-2.239 4.996-3.001 5.845c-.761.853-3.85 2.07-5.337.799-1.069-1.387 1.052-2.217 1.438-3.589.505-1.787.288-3.216.783-4.563.408-1.107 2.657-2.851 2.657-2.851z",
    fill: "url(#paint78_linear)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M424.306 331.502l.006.019c.023.744-.525 1.991-.525 1.991s-2.241 4.994-3.002 5.845c-.761.852-3.851 2.072-5.339.798a1.827 1.827 0 01-.148-.229c.046.202.138.391.27.552 1.487 1.271 4.576.054 5.337-.799.762-.849 3.001-5.845 3.001-5.845s.551-1.244.528-1.989a3.709 3.709 0 00-.128-.343z",
    fill: "#000"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M416.769 330.604c.654-.446 3.355-1.429 3.355-1.429.162.201.372.357.61.455.04.01.077.025.119.039.667.005 1.877.632 1.129 1.978-1.449 2.614-4.797 2.522-4.43 1.282.25-.832-.437-1.816-.783-2.325z",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M417.491 333.609c-.103-.412-.223-1.306.832-1.454 1.105-.157 2.353.355 2.251 1.004-.214 1.35-2.98.866-3.083.45z",
    fill: "url(#paint79_linear)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M421.618 329.226c-1.253-1.692-10.54-12.891-14.915-15.121 1.471-6.181 5.288-14.211 4.076-20.832h-9.318s-5.525 19.605-1.988 24.276c2.678 3.542 14.53 12.587 18.944 15.44 1.515 0 3.749-2.45 3.201-3.763z",
    fill: "url(#paint80_linear)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M413.711 345.503c1.6.263 2.063 2.846 1.263 4.469-.496.557-1.752 1.08-1.752 1.08s-5.055 2.078-6.192 2.169c-1.138.093-3.663-.334-3.87-2.28.196-1.19 1.192-1.515 2.417-2.244 1.593-.948 2.961-2.324 4.246-2.956 1.057-.52 3.888-.238 3.888-.238z",
    fill: "url(#paint81_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M407.065 352.699c1.17-.092 6.373-2.228 6.373-2.228s1.214-.511 1.749-1.064a3.742 3.742 0 01-.213.565c-.496.557-1.752 1.08-1.752 1.08s-5.055 2.078-6.192 2.169c-1.138.093-3.663-.334-3.87-2.28.008-.04.024-.077.03-.119.537 1.603 2.805 1.966 3.875 1.877z",
    fill: "#000"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M410.266 343.787c.78.127 3.418 1.276 3.418 1.276-.02.257.024.516.13.751l.059.108c.479.465.986 1.289-.481 1.751-2.846.897-5.272-1.017-4.153-1.66.752-.431.928-1.62 1.027-2.226z",
    fill: "#fff"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M408.756 346.397c.211-.282.704-1.034 1.573-.414.91.65 1.114 1.429 1.008 2.079-.107.648-1.979.168-2.051.07-.07-.097-.53-1.735-.53-1.735z",
    fill: "url(#paint82_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M409.635 295.929c0 8.766-.09 15.598-.09 23.253 0 8.753-.668 19.606-.575 26.943 1.406 1.743 4.974 1.305 5.727-.042.927-6.659 2.999-16.803 2.486-24.071 2.212-9.577 4.347-20.845 3.446-28.361-2.117.673-8.876 1.605-10.994 2.278z",
    fill: "url(#paint83_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M399.011 271.367c-3.142 1.752-6.151 11.457-7.503 13.238-1.351 1.78-3.876 4.045-3.876 4.045 1.454 1.213 4.635 2.992 4.635 2.992 1.535-1.294 4.114-1.027 7.2-8.757 3.085-7.729-.456-11.518-.456-11.518z",
    fill: "#0085AA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M415.335 274.592c-1.851-2.32-6.4-5.558-9.379-5.778-5.065-.374-8.884 3.504-9.603 7.323-.636 3.38 5.608 20.447 4.523 24.93.535 2.365 4.46 3.646 6.104 4.008 7.15 1.571 14.377.567 14.458-4.008.265-15.168-3.433-23.8-6.103-26.475z",
    fill: "url(#paint84_linear)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M359.745 324.652l17.832 10.314c.98.565 1.868.618 2.51.247.642-.371 1.039-1.167 1.039-2.301v-20.625a7.853 7.853 0 00-3.549-6.157l-17.832-10.313c-.981-.567-1.868-.621-2.508-.249-.644.371-1.04 1.167-1.04 2.301v20.625a7.858 7.858 0 003.548 6.158z",
    fill: "#2E7E94"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M381.126 332.912v-20.625a7.853 7.853 0 00-3.548-6.157l-17.833-10.313c-.98-.567-1.867-.621-2.508-.249l23.358-13.51c.642-.371 1.53-.317 2.509.249l17.832 10.313a7.858 7.858 0 013.549 6.157v20.626c0 1.134-.398 1.93-1.04 2.301l-23.358 13.509c.642-.371 1.039-1.167 1.039-2.301z",
    fill: "url(#paint85_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M383.777 306.649a7.262 7.262 0 00-2.51-2.654l-17.833-10.313c-.979-.567-1.866-.621-2.507-.249l-1.121.647c.643-.371 1.53-.317 2.51.25l17.832 10.312a7.84 7.84 0 013.548 6.158v20.625c0 1.134-.396 1.931-1.038 2.301l1.119-.647c.642-.371 1.039-1.168 1.039-2.302v-20.625a7.26 7.26 0 00-1.039-3.503z",
    fill: "url(#paint86_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M386.775 304.915a7.252 7.252 0 00-2.509-2.654l-17.833-10.313c-.979-.567-1.867-.62-2.508-.248l-1.12.647c.641-.372 1.528-.318 2.509.248l17.832 10.313a7.852 7.852 0 013.55 6.158v20.625c0 1.133-.398 1.93-1.04 2.301l1.119-.648c.643-.371 1.04-1.167 1.04-2.3v-20.626a7.275 7.275 0 00-1.04-3.503z",
    fill: "url(#paint87_linear)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M389.773 303.181a7.244 7.244 0 00-2.509-2.654l-17.833-10.314c-.979-.565-1.867-.619-2.508-.247l-1.12.646c.643-.371 1.53-.317 2.51.25l17.832 10.313a7.866 7.866 0 013.549 6.156v20.627c0 1.133-.398 1.929-1.04 2.3l1.119-.647c.643-.372 1.04-1.168 1.04-2.301v-20.627a7.272 7.272 0 00-1.04-3.502z",
    fill: "url(#paint88_linear)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M392.771 301.447a7.244 7.244 0 00-2.509-2.654l-17.832-10.312c-.979-.567-1.867-.622-2.509-.25l-1.12.647c.644-.371 1.529-.317 2.51.25l17.832 10.313a7.858 7.858 0 013.549 6.156v20.626c0 1.134-.397 1.931-1.04 2.302l1.119-.648c.643-.371 1.04-1.168 1.04-2.301V304.95a7.261 7.261 0 00-1.04-3.503z",
    fill: "url(#paint89_linear)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M395.769 299.713a7.244 7.244 0 00-2.509-2.654l-17.832-10.313c-.979-.567-1.866-.621-2.509-.248l-1.12.647c.644-.371 1.531-.318 2.51.249l17.832 10.312a7.861 7.861 0 013.549 6.157v20.626c0 1.134-.397 1.931-1.04 2.301l1.119-.647c.643-.371 1.04-1.168 1.04-2.301v-20.626a7.254 7.254 0 00-1.04-3.503z",
    fill: "url(#paint90_linear)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M398.768 297.979a7.25 7.25 0 00-2.508-2.654l-17.834-10.313c-.979-.567-1.866-.62-2.508-.248l-1.119.646c.642-.371 1.529-.317 2.509.25l17.831 10.313a7.857 7.857 0 013.549 6.156v20.627c0 1.133-.397 1.929-1.038 2.3l1.118-.647c.642-.372 1.039-1.168 1.039-2.302v-20.625a7.274 7.274 0 00-1.039-3.503z",
    fill: "url(#paint91_linear)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M401.767 296.245a7.268 7.268 0 00-2.509-2.654l-17.833-10.313c-.98-.567-1.867-.62-2.509-.248l-1.12.646c.643-.371 1.53-.318 2.51.249l17.831 10.314a7.857 7.857 0 013.549 6.156v20.626c0 1.133-.397 1.93-1.039 2.301l1.12-.647c.642-.372 1.039-1.168 1.039-2.301v-20.626a7.271 7.271 0 00-1.039-3.503z",
    fill: "url(#paint92_linear)"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M405.212 307.777c-.207.293-.756 3.51 1.687 4.014 1.058-.822.904-3.966-1.687-4.014z",
    fill: "#A5C4CC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M406.568 307.504l-1.35.801c-.77.396-2.904.387-4.273-.543-1.369-.931-1.17 1.397.297 1.791 1.469.394 1.593.956-.502 1.763a5.527 5.527 0 00-2.214 1.57c-.63.929-1.161 2.818.233 3.421 1.131.488 3.854-1.424 4.684-1.964 2.291-1.489 1.698-1.887 2.966-2.818 1.265-.933 1.582-.964 1.582-.964l-1.423-3.057z",
    fill: "#FCD1A9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M412.065 274.712c1.503-.622 4.214-1.013 5.827 3.649.916 2.645 1.695 11.925.508 16.617-1.626 6.417-5.643 13.055-11.501 16.813.763-1.307-.305-3.681-1.687-4.014 4.037-4.594 6.869-10.574 6.869-13.515 0-4.862-.893-12.296-1.249-13.788-.749-3.136-.252-5.148 1.233-5.762z",
    fill: "url(#paint93_linear)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M406.594 262.078c.186-1.644-5.486 1.704-5.258 3.876.186 1.766.699 3.32-1.085 4.425-.615.493-2.718 3.926.518 3.963 4.627.056 5.861-1.216 9.205-4.087-1.995-1.129-3.981-2.846-3.38-8.177z",
    fill: "#FCD1A9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M407.93 261.105l-2.304-3.247h-10.03v6.047c0 3.342 2.246 6.048 5.013 6.048 2.69 0 5.187-2.23 5.317-5.431l1.217-.421.787-2.996z",
    fill: "#FCD1A9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M400.843 271.57c2.396 0 5.364-3.856 5.083-7.045-.122 3.006-2.619 5.173-5.114 5.422a4.27 4.27 0 01-.561.432c-.06.052-.115.109-.166.17 0 .487.323 1.021.758 1.021z",
    fill: "#F2C39D"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M396.181 255.127c-.917-.16-1-.924 2.718-2.213 2.161-1.062 5.223-1.387 7.205-.159 2.685 1.666 3.496 4.114 3.014 7.185-.479 3.074-2.445 5.996-2.445 5.996-.297.301-.341-1.117-.098-2.165.186-.267.306-.575.349-.898.711-3.122-1.196-2.656-1.457-2.393-.588.243.55 2.826-1.174 2.567-.834-.122-.72-2.455-.717-3.275a3.526 3.526 0 00-.376.099c-1.423.792-6.259 1.367-3.574-.315-1.871 0-4.42.865-5.281-.324-1.022-1.416.615-2.958 1.836-4.105z",
    fill: "#024455"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M307.489 373.13h30.033v6.301h-30.033v-6.301z",
    fill: "url(#paint94_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M320.976 382.223h32.292v6.299h-32.292v-6.299z",
    fill: "url(#paint95_linear)"
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M333.901 377.488c0-4.948 3.133-5.09 3.133-5.09s1.739.177 4.531-.874c3.518-1.323 6.468-.968 4.326 2.99-.022.05-.047.099-.074.146a1.934 1.934 0 01-.693.609l-6.843 4.019c-1.042.598-4.356-.782-4.38-1.8z",
    fill: "url(#paint96_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M333.92 377.044c.059 1.016 3.326 2.37 4.361 1.778l6.843-4.019c.343-.204.666-.439.965-.704-.065.137-.118.266-.198.415-.022.05-.047.099-.074.146a1.934 1.934 0 01-.693.609l-6.843 4.019c-.974.56-3.945-.615-4.335-1.604a.956.956 0 01-.029-.199 3.245 3.245 0 01.003-.441z",
    fill: "#000"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M335.175 371.747c.721.065 1.437.186 2.139.364.673-.174 2.893-.255 4.346-.684.432-.127.839-.399 1.297-.052.574.707-.92 2.434-4.003 3.767-1.09.687-1.973.25-2.394-.167a2.218 2.218 0 00-.77-.879 2.002 2.002 0 00-.74-.312.26.26 0 00-.009-.068s-.202-1.969.134-1.969z",
    fill: "#FCD1A9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M336.722 339.216c-1.374-4.22-.74-9.094.28-13.993 3.092.056 8.948-1.678 12.04-1.622-1.151 9.313-3.744 17.499-5.292 26.52-1.66 8.767-3.632 15.204-5.267 22.502-.598 1.36-3.51.746-3.51-.068-.433-6.72-.143-14.514 1.844-22.265-.139-3.507.46-7.584-.095-11.074z",
    fill: "#024455"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M349.499 386.581c0-4.948 3.129-5.09 3.129-5.09s1.836.081 4.628-.971c3.517-1.324 6.374-.871 4.233 3.087a3.542 3.542 0 01-.076.147 1.917 1.917 0 01-.694.608l-6.842 4.019c-1.042.598-4.355-.782-4.378-1.8z",
    fill: "url(#paint97_linear)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M349.515 386.137c.06 1.016 3.327 2.37 4.362 1.78l6.842-4.021c.343-.204.667-.44.966-.704-.064.136-.118.267-.196.415-.022.047-.048.095-.076.147a1.917 1.917 0 01-.694.608l-6.842 4.019c-.973.56-3.943-.614-4.335-1.604a.977.977 0 01-.03-.2 3.587 3.587 0 01.003-.44z",
    fill: "#000"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M350.771 380.839c.722.065 1.438.187 2.14.365.671-.176 2.892-.254 4.345-.684.433-.127.841-.399 1.297-.051.573.706-.921 2.434-4.003 3.766-1.09.687-1.972.25-2.393-.167a2.215 2.215 0 00-.772-.879 2.002 2.002 0 00-.738-.313.385.385 0 00-.009-.067s-.203-1.97.133-1.97z",
    fill: "#FCD1A9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M344.941 345.5c-2.635-10.605-8.579-4.532-7.94-20.277 3.061-.45 13.994 6.475 17.056 6.025 1.792 11.414 1.42 18.464 1.364 27.614-.207 8.923-.79 15.027-1.213 22.49-.368 1.441-3.629 1.329-3.629.463-1.523-6.558-2.737-14.556-2.038-22.527-.912-4.418-2.608-9.1-3.6-13.788z",
    fill: "url(#paint98_linear)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M338.579 341.576c4.987 3.054 12.832 4.944 17.879 2.709.522-2.951-4.037-22.41-1.037-27.535.654-1.118 2.759-.205 3.329-1.419 1.477-3.15 2.885-9.7 2.885-10.696 0-2.118-1.699-4.316-3.456-5.486-2.405-1.605-5.819-3.751-8.831-3.163-6.577 1.848-11.233 18.849-16.062 38.519.489 2.228 2.295 5.234 5.293 7.071z",
    fill: "url(#paint99_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M351.88 321.845c-.323-2.427 2.18-6.714 3.611-7.199 1.431-.485 2.688-1.051 2.688-2.7 0-1.649-.678-4.246-.321-6.203l3.674-.242c-.349 2.134-1.541 7.182-2.782 9.83-.57 1.214-2.675.301-3.329 1.419-2.999 5.125 1.559 24.584 1.037 27.535 0 0-1.833-9.336-2.401-13.037-.57-3.701-1.854-6.976-2.177-9.403z",
    fill: "url(#paint100_linear)"
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M350.468 297.477c2.017-1.35 1.894-2.435 1.673-4.383a9.567 9.567 0 01-.468-3.363c.161-4.312 3.039-7.936 6.39-7.578 6.754.72 5.417 4.243 5.256 8.555-.149 3.995-2.062 6.675-5.103 7.025-.026.656.173 1.273.989 1.881-2.261 1.243-5.771.573-7.185-.012-1.381-.57-2.509-1.204-1.552-2.125zm28.373 25.051c.594.053 1.028-1.379 2.002-1.5.973-.118 3.034-.436 2.989.16-.039.5-1.796.413-1.557.671.688.742 2.34.007 2.74-.628.403-.637.978-.687.92-.04-.057.645-.433 3.538-2.764 4.187-2.331.649-5.043.259-5.043.259l.713-3.109z",
    fill: "#FCD1A9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M378.965 325.887s2.077-1.373.168-3.719c-6.737-1.204-15.113-8.814-17.163-17.86-1.246-3.526-5.193-1.065-4.374 3.416 1.29 7.059 9.492 17.825 21.369 18.163z",
    fill: "url(#paint101_linear)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M364.217 287.982c-.123-2.503-2.148-6.712-6.606-6.397-4.307.304-6.143 3.369-6.188 7.107-.036 2.934-2.651 11.234-9.229 10.753 2.815 5.213 22.89 6.144 22.023-11.463z",
    fill: "#024455"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 146.529,
    y1: 137.137,
    x2: 146.529,
    y2: 44.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#F8FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#E5F2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 174.818,
    y1: 137.137,
    x2: 174.818,
    y2: 44.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#F6FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 420.793,
    y1: 203.611,
    x2: 382.649,
    y2: 203.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 353.707,
    y1: 255.229,
    x2: 272.018,
    y2: 255.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFEAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#E1F1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 167.697,
    y1: 362.069,
    x2: 214.891,
    y2: 362.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 21.208,
    y1: 220.363,
    x2: 114.786,
    y2: 220.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 338.981,
    y1: 249.698,
    x2: 317.708,
    y2: 212.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#89A5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#9AB7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C6E6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#CEEFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 131.996,
    y1: 142.717,
    x2: 92.367,
    y2: 142.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D5EBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#E2F1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#F6FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 122.349,
    y1: 137.155,
    x2: 108.269,
    y2: 137.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 102.465,
    y1: 144.868,
    x2: 98.525,
    y2: 144.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5CAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#BEDEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -3940.79,
    y1: 3136.84,
    x2: -3990.55,
    y2: 3136.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 109.047,
    y1: 148.529,
    x2: 103.989,
    y2: 148.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5CBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#BCDDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -5176.65,
    y1: 3056.8,
    x2: -5258.22,
    y2: 3056.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -5777.08,
    y1: 2994.52,
    x2: -5872.86,
    y2: 2994.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -20831.8,
    y1: 2705.99,
    x2: -22096.4,
    y2: 2705.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 239.429,
    y1: 384.248,
    x2: 291.198,
    y2: 384.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 279.579,
    y1: 378.258,
    x2: 263.94,
    y2: 378.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8F0F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 283.996,
    y1: 389.801,
    x2: 274.02,
    y2: 389.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF0FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 260.114,
    y1: 389.714,
    x2: 269.698,
    y2: 389.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCF0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9DEE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 259.145,
    y1: 382.027,
    x2: 252.341,
    y2: 382.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#B9DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF0FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 21.459,
    y1: 297.571,
    x2: 44.243,
    y2: 297.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 293.863,
    y1: 308.383,
    x2: 314.449,
    y2: 308.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 297.355,
    y1: 188.83,
    x2: 354.042,
    y2: 188.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 361.447,
    y1: 181.505,
    x2: 347.634,
    y2: 190.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 364.722,
    y1: 183.837,
    x2: 342.683,
    y2: 183.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55AEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7FDBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4193AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 364.805,
    y1: 176.753,
    x2: 342.613,
    y2: 176.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#ECF6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#ECF6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#E0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCEFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 349.548,
    y1: 172.84,
    x2: 356.737,
    y2: 160.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 138.943,
    y1: 259.433,
    x2: 267.319,
    y2: 259.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 281.042,
    y1: 273.798,
    x2: 152.665,
    y2: 273.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 215.524,
    y1: 244.928,
    x2: 152.665,
    y2: 244.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 247.641,
    y1: 216.51,
    x2: 182.87,
    y2: 242.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 251.792,
    y1: 219.296,
    x2: 180.543,
    y2: 219.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#D2EAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAEFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 267.415,
    y1: 169.003,
    x2: 187.014,
    y2: 222.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#E0F0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 238.172,
    y1: 240.262,
    x2: 184.048,
    y2: 162.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 270.201,
    y1: 190.743,
    x2: 224.891,
    y2: 213.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 257.447,
    y1: 212.183,
    x2: 216.551,
    y2: 212.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 259.813,
    y1: 156.244,
    x2: 209.642,
    y2: 191.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 189.142,
    y1: 271.711,
    x2: 197.614,
    y2: 257.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#195C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#19677C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#0B7795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#0381A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#0085AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#057FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#126F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#195C6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 182.464,
    y1: 267.766,
    x2: 190.936,
    y2: 253.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 266.133,
    y1: 163.581,
    x2: 190.149,
    y2: 163.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#245D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 229.51,
    y1: 164.219,
    x2: 201.825,
    y2: 164.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 78.959,
    y1: 332.826,
    x2: 142.306,
    y2: 332.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 176.809,
    y1: 333.984,
    x2: 88.463,
    y2: 333.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#CEEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#BBDDE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 152.425,
    y1: 322.226,
    x2: 88.462,
    y2: 322.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#F2F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 152.978,
    y1: 242.91,
    x2: 106.401,
    y2: 298.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#CEEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#BBDDE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 158.684,
    y1: 253.402,
    x2: 91.602,
    y2: 285.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 129.043,
    y1: 271.747,
    x2: 116.907,
    y2: 250.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#42131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#1E080E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#080204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: -16325.1,
    y1: 8993,
    x2: -16502.2,
    y2: 8520.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#42131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#1E080E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#080204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: -16451.7,
    y1: 9103.82,
    x2: -16628.8,
    y2: 8631.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#42131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#1E080E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#080204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: -29339.9,
    y1: 15290.1,
    x2: -29937,
    y2: 13626.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#42131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#1E080E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#080204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 130.53,
    y1: 268.934,
    x2: 116.171,
    y2: 244.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#0F3742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#07191E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#020708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 118.962,
    y1: 273.163,
    x2: 109.172,
    y2: 256.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#023442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#01181E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#000608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: -21165.2,
    y1: 11262.2,
    x2: -21455.7,
    y2: 10470.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#42131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#1E080E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#080204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 62.577,
    y1: 353.357,
    x2: 96.203,
    y2: 353.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 47.416,
    y1: 344.417,
    x2: 81.042,
    y2: 344.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 88.134,
    y1: 341.78,
    x2: 79.653,
    y2: 346.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 103.459,
    y1: 350.716,
    x2: 94.978,
    y2: 355.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 96.94,
    y1: 312.931,
    x2: 77.816,
    y2: 315.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 84.609,
    y1: 264.561,
    x2: 74.8,
    y2: 294.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#C4E2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDAE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 100.482,
    y1: 284.196,
    x2: 78.225,
    y2: 284.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#E4F1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#D4EDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 113.439,
    y1: 280.374,
    x2: 93.7,
    y2: 280.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#F0F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 270.977,
    y1: 108.177,
    x2: 227.284,
    y2: 82.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: -5984.51,
    y1: 23632.4,
    x2: -3342.71,
    y2: 23632.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 297.041,
    y1: 135.452,
    x2: 259.921,
    y2: 135.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 87.327,
    y1: 178.866,
    x2: 61.367,
    y2: 186.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 59.884,
    y1: 261.442,
    x2: 33.181,
    y2: 261.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#DDECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#F6FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 17.566,
    y1: 256.298,
    x2: 44.268,
    y2: 256.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 47.776,
    y1: 248.481,
    x2: 41.146,
    y2: 248.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3C6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 36.234,
    y1: 267.289,
    x2: 51.918,
    y2: 267.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 55.425,
    y1: 263.561,
    x2: 48.796,
    y2: 263.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 62.545,
    y1: 251.723,
    x2: 56.598,
    y2: 252.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 40.83,
    y1: 272.434,
    x2: 67.533,
    y2: 272.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: -8031.91,
    y1: 13878.3,
    x2: -8171.44,
    y2: 13878.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3C6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 367.92,
    y1: 349.562,
    x2: 410.993,
    y2: 349.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 377.682,
    y1: 338.594,
    x2: 417.814,
    y2: 338.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 423.265,
    y1: 333.112,
    x2: 415.602,
    y2: 335.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 420.178,
    y1: 332.761,
    x2: 418.169,
    y2: 334.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 421.703,
    y1: 313.131,
    x2: 398.29,
    y2: 313.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#134350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#113B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 413.802,
    y1: 348.007,
    x2: 405.799,
    y2: 353.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 411.03,
    y1: 346.621,
    x2: 408.963,
    y2: 347.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 419.324,
    y1: 311.375,
    x2: 408.502,
    y2: 312.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 421.451,
    y1: 287.278,
    x2: 396.307,
    y2: 287.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#00A7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#009AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 397.479,
    y1: 325.155,
    x2: 374.569,
    y2: 285.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#3E97AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#67CDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 384.816,
    y1: 313.461,
    x2: 359.806,
    y2: 313.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 387.815,
    y1: 311.727,
    x2: 362.805,
    y2: 311.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 390.813,
    y1: 309.993,
    x2: 365.803,
    y2: 309.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 393.811,
    y1: 308.26,
    x2: 368.801,
    y2: 308.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 396.809,
    y1: 306.525,
    x2: 371.799,
    y2: 306.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 399.807,
    y1: 304.791,
    x2: 374.798,
    y2: 304.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 402.806,
    y1: 303.057,
    x2: 377.796,
    y2: 303.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 415.327,
    y1: 287.898,
    x2: 399.448,
    y2: 302.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57ECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#37E4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#19DCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#07D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 307.489,
    y1: 376.28,
    x2: 337.522,
    y2: 376.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 320.976,
    y1: 385.372,
    x2: 353.268,
    y2: 385.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECF5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#D4E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear",
    x1: 344.993,
    y1: 373.675,
    x2: 336.393,
    y2: 378.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 360.603,
    y1: 382.719,
    x2: 351.96,
    y2: 387.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear",
    x1: 353.125,
    y1: 344.126,
    x2: 336.388,
    y2: 346.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#245E97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear",
    x1: 361.635,
    y1: 320.575,
    x2: 333.286,
    y2: 320.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 361.533,
    y1: 324.893,
    x2: 351.852,
    y2: 324.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E2F2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 379.94,
    y1: 314.258,
    x2: 357.485,
    y2: 314.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6901"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-34.95 0 0 -35.0098 362.755 153.597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#FFAC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#FFA46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#FF966E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#FF8170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#FF6771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.01969 4.0086 -3.91714 -4.90516 241.023 210.248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#F67D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#DE715C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#9F5142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3D1F19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(130.227 92.056 160.22) scale(5.84585 5.06079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.2b5a6a01b25bef4ab29045d5cb404c49.svg";
export { ForwardRef as ReactComponent };